/* tslint:disable */
/* eslint-disable */
/**
 * AggregateBusinessManage API
 * 集計行に対する情報を操作するやつ
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 集計情報
 * @export
 * @interface AggregateBusiness
 */
export interface AggregateBusiness {
    /**
     * 集計ID
     * @type {string}
     * @memberof AggregateBusiness
     */
    'aggregateBusinessId': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof AggregateBusiness
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof AggregateBusiness
     */
    'supplierName': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof AggregateBusiness
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof AggregateBusiness
     */
    'businessName': string;
    /**
     * 容量
     * @type {string}
     * @memberof AggregateBusiness
     */
    'package': string;
    /**
     * 置場コード
     * @type {string}
     * @memberof AggregateBusiness
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof AggregateBusiness
     */
    'warehouse': string;
    /**
     * 単位
     * @type {string}
     * @memberof AggregateBusiness
     */
    'unit'?: string;
    /**
     * 最小発注数量
     * @type {string}
     * @memberof AggregateBusiness
     */
    'moq'?: string;
    /**
     * 発注単位
     * @type {number}
     * @memberof AggregateBusiness
     */
    'orderPackage'?: number;
    /**
     * 在庫年月日
     * @type {number}
     * @memberof AggregateBusiness
     */
    'executionDate': number;
    /**
     * リードタイム
     * @type {number}
     * @memberof AggregateBusiness
     */
    'leadTime': number;
    /**
     * リードタイムの単位
     * @type {string}
     * @memberof AggregateBusiness
     */
    'leadTimeUnit': string;
    /**
     * 国内輸送日数(In-transit days)
     * @type {number}
     * @memberof AggregateBusiness
     */
    'inTransitDays'?: number;
    /**
     * 標準在庫指数（下限）
     * @type {string}
     * @memberof AggregateBusiness
     */
    'stdInventoryIndicesMin': string;
    /**
     * 標準在庫指数（上限）
     * @type {string}
     * @memberof AggregateBusiness
     */
    'stdInventoryIndicesMax': string;
    /**
     * 標準在庫指数の単位
     * @type {string}
     * @memberof AggregateBusiness
     */
    'stdInventoryIndicesUnit': string;
    /**
     * 製造社
     * @type {string}
     * @memberof AggregateBusiness
     */
    'manufacturer'?: string;
    /**
     * key,value形式のユーザー任意項目(ほぼ顧客台帳ID用)
     * @type {string}
     * @memberof AggregateBusiness
     */
    'userCustomParameters'?: string;
    /**
     * 集計メモ
     * @type {string}
     * @memberof AggregateBusiness
     */
    'aggregateBusinessNote'?: string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof AggregateBusiness
     */
    'aggregateBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 
     * @type {UserData}
     * @memberof AggregateBusiness
     */
    'lastCheckedUser'?: UserData;
    /**
     * 最後に集計をチェックした日時
     * @type {number}
     * @memberof AggregateBusiness
     */
    'lastCheckedAt'?: number;
    /**
     * 
     * @type {number}
     * @memberof AggregateBusiness
     */
    'createAt': number;
    /**
     * 
     * @type {number}
     * @memberof AggregateBusiness
     */
    'updateAt': number;
}
/**
 * 
 * @export
 * @interface AggregateBusinessAlertVisibilityPutRequest
 */
export interface AggregateBusinessAlertVisibilityPutRequest {
    /**
     * 集計IDリスト
     * @type {Array<string>}
     * @memberof AggregateBusinessAlertVisibilityPutRequest
     */
    'aggregateBusinessIds': Array<string>;
    /**
     * 非表示にするかどうか
     * @type {boolean}
     * @memberof AggregateBusinessAlertVisibilityPutRequest
     */
    'isDismissed': boolean;
}
/**
 * 
 * @export
 * @interface AggregateBusinessBulkPutRequest
 */
export interface AggregateBusinessBulkPutRequest {
    /**
     * 変更対象IDリスト
     * @type {Array<string>}
     * @memberof AggregateBusinessBulkPutRequest
     */
    'targetIds': Array<string>;
    /**
     * 
     * @type {BulkPutAggregateBusinessRequestUpdateInfos}
     * @memberof AggregateBusinessBulkPutRequest
     */
    'updateInfos': BulkPutAggregateBusinessRequestUpdateInfos;
    /**
     * フィールドをNoneにする対象キー
     * @type {Array<string>}
     * @memberof AggregateBusinessBulkPutRequest
     */
    'nullKeys'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AggregateBusinessGetUniqueKeysParameter
 */
export interface AggregateBusinessGetUniqueKeysParameter {
    /**
     * 置場コード
     * @type {string}
     * @memberof AggregateBusinessGetUniqueKeysParameter
     */
    'warehouseNumber': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof AggregateBusinessGetUniqueKeysParameter
     */
    'supplierNumber': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof AggregateBusinessGetUniqueKeysParameter
     */
    'businessNumber': string;
    /**
     * 容量
     * @type {string}
     * @memberof AggregateBusinessGetUniqueKeysParameter
     */
    'package': string;
}
/**
 * 集計グループデータ
 * @export
 * @interface AggregateBusinessGroupFilterData
 */
export interface AggregateBusinessGroupFilterData {
    /**
     * 
     * @type {string}
     * @memberof AggregateBusinessGroupFilterData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateBusinessGroupFilterData
     */
    'name'?: string;
}
/**
 * 集計グループフィルター情報取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface AggregateBusinessGroupFilterInfoResponse
 */
export interface AggregateBusinessGroupFilterInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof AggregateBusinessGroupFilterInfoResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof AggregateBusinessGroupFilterInfoResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof AggregateBusinessGroupFilterInfoResponse
     */
    'message': string;
    /**
     * 
     * @type {AggregateBusinessGroupFilterInfoResponseAllOfResult}
     * @memberof AggregateBusinessGroupFilterInfoResponse
     */
    'result': AggregateBusinessGroupFilterInfoResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface AggregateBusinessGroupFilterInfoResponseAllOfResult
 */
export interface AggregateBusinessGroupFilterInfoResponseAllOfResult {
    /**
     * 集計グループデータの配列
     * @type {Array<AggregateBusinessGroupFilterData>}
     * @memberof AggregateBusinessGroupFilterInfoResponseAllOfResult
     */
    'aggregateBusinessGroupFilterInfo': Array<AggregateBusinessGroupFilterData>;
}
/**
 * 集計ID取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface AggregateBusinessIdResponse
 */
export interface AggregateBusinessIdResponse {
    /**
     * 
     * @type {number}
     * @memberof AggregateBusinessIdResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof AggregateBusinessIdResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof AggregateBusinessIdResponse
     */
    'message': string;
    /**
     * 
     * @type {AggregateBusinessIdResponseAllOfResult}
     * @memberof AggregateBusinessIdResponse
     */
    'result': AggregateBusinessIdResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface AggregateBusinessIdResponseAllOfResult
 */
export interface AggregateBusinessIdResponseAllOfResult {
    /**
     * 存在しない場合はnullを返す
     * @type {string}
     * @memberof AggregateBusinessIdResponseAllOfResult
     */
    'aggregateBusinessId': string;
}
/**
 * 
 * @export
 * @interface AggregateBusinessMemoAggregateBusinessIdPutRequest
 */
export interface AggregateBusinessMemoAggregateBusinessIdPutRequest {
    /**
     * 
     * @type {AggregateBusinessMemoRequestInfo}
     * @memberof AggregateBusinessMemoAggregateBusinessIdPutRequest
     */
    'aggregateBusinessMemoInfo': AggregateBusinessMemoRequestInfo;
}
/**
 * 集計にメモを追加する際のリクエストの型
 * @export
 * @interface AggregateBusinessMemoRequestInfo
 */
export interface AggregateBusinessMemoRequestInfo {
    /**
     * 
     * @type {string}
     * @memberof AggregateBusinessMemoRequestInfo
     */
    'memoText': string;
}
/**
 * 
 * @export
 * @interface AggregateBusinessPostRequest
 */
export interface AggregateBusinessPostRequest {
    /**
     * 
     * @type {PostAggregateBusinessRequestInfo}
     * @memberof AggregateBusinessPostRequest
     */
    'postAggregateBusinessInfo': PostAggregateBusinessRequestInfo;
}
/**
 * 
 * @export
 * @interface AggregateBusinessPutRequest
 */
export interface AggregateBusinessPutRequest {
    /**
     * 
     * @type {PutAggregateBusinessRequestInfo}
     * @memberof AggregateBusinessPutRequest
     */
    'putAggregateBusinessRequestInfo': PutAggregateBusinessRequestInfo;
}
/**
 * 
 * @export
 * @interface AggregateBusinessRecommendHiddenPutRequest
 */
export interface AggregateBusinessRecommendHiddenPutRequest {
    /**
     * 集計IDリスト
     * @type {Array<string>}
     * @memberof AggregateBusinessRecommendHiddenPutRequest
     */
    'aggregateBusinessIds': Array<string>;
    /**
     * 非表示にするかどうか
     * @type {boolean}
     * @memberof AggregateBusinessRecommendHiddenPutRequest
     */
    'isHidden': boolean;
}
/**
 * 集計取引担当者取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface AggregateBusinessResponsibleUserResponse
 */
export interface AggregateBusinessResponsibleUserResponse {
    /**
     * 
     * @type {number}
     * @memberof AggregateBusinessResponsibleUserResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof AggregateBusinessResponsibleUserResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof AggregateBusinessResponsibleUserResponse
     */
    'message': string;
    /**
     * 
     * @type {AggregateBusinessResponsibleUserResponseAllOfResult}
     * @memberof AggregateBusinessResponsibleUserResponse
     */
    'result': AggregateBusinessResponsibleUserResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface AggregateBusinessResponsibleUserResponseAllOfResult
 */
export interface AggregateBusinessResponsibleUserResponseAllOfResult {
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof AggregateBusinessResponsibleUserResponseAllOfResult
     */
    'aggregateBusinessResponsibleUsers': Array<UserData>;
}
/**
 * 入荷情報
 * @export
 * @interface Arrival
 */
export interface Arrival {
    /**
     * 入荷ID
     * @type {string}
     * @memberof Arrival
     */
    'arrivalId': string;
    /**
     * 入荷年
     * @type {number}
     * @memberof Arrival
     */
    'arrivalTargetYear': number;
    /**
     * 入荷月
     * @type {number}
     * @memberof Arrival
     */
    'arrivalTargetMonth': number;
    /**
     * 入荷数量
     * @type {string}
     * @memberof Arrival
     */
    'arrivalAmount': string;
}
/**
 * 集計情報の一括編集APIのリクエストの型
 * @export
 * @interface BulkPutAggregateBusinessRequestUpdateInfos
 */
export interface BulkPutAggregateBusinessRequestUpdateInfos {
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'warehouse'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'warehouseNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'supplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'supplierNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'businessNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'package'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'manufacturer'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'stdInventoryIndexMin'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'stdInventoryIndexMax'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'stdInventoryIndexUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'leadTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'leadTimeUnit'?: string;
    /**
     * 国内輸送日数(In-transit days)
     * @type {number}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'inTransitDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'moq'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'orderPackage'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'purchaseUnitPrice'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'userUniqueNumber'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'aggregateBusinessResponsibleUserIdList'?: Array<string>;
    /**
     * 
     * @type {Array<BusinessFreeColumnValueInput>}
     * @memberof BulkPutAggregateBusinessRequestUpdateInfos
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValueInput>;
}
/**
 * 取引自由欄値
 * @export
 * @interface BusinessFreeColumnValue
 */
export interface BusinessFreeColumnValue {
    /**
     * 
     * @type {number}
     * @memberof BusinessFreeColumnValue
     */
    'columnNo': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessFreeColumnValue
     */
    'headerName': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessFreeColumnValue
     */
    'value': string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessFreeColumnValue
     */
    'isMulti': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessFreeColumnValue
     */
    'isConfigured': boolean;
    /**
     * 自由欄の対象（集計取引/関連取引）。columnNo は対象ごとに 1 から採番されるため、未管理登録などで対象を判別する必要がある場合に指定する。
     * @type {string}
     * @memberof BusinessFreeColumnValue
     */
    'target'?: BusinessFreeColumnValueTargetEnum;
}

export const BusinessFreeColumnValueTargetEnum = {
    Aggregate: 'aggregate',
    Base: 'base'
} as const;

export type BusinessFreeColumnValueTargetEnum = typeof BusinessFreeColumnValueTargetEnum[keyof typeof BusinessFreeColumnValueTargetEnum];

/**
 * 取引自由欄値の登録・更新リクエスト用の型
 * @export
 * @interface BusinessFreeColumnValueInput
 */
export interface BusinessFreeColumnValueInput {
    /**
     * 
     * @type {number}
     * @memberof BusinessFreeColumnValueInput
     */
    'columnNo': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessFreeColumnValueInput
     */
    'value': string;
    /**
     * 自由欄の対象（集計取引/関連取引）。columnNo は対象ごとに 1 から採番されるため、未管理登録などで対象を判別する必要がある場合に指定する。
     * @type {string}
     * @memberof BusinessFreeColumnValueInput
     */
    'target'?: BusinessFreeColumnValueInputTargetEnum;
}

export const BusinessFreeColumnValueInputTargetEnum = {
    Aggregate: 'aggregate',
    Base: 'base'
} as const;

export type BusinessFreeColumnValueInputTargetEnum = typeof BusinessFreeColumnValueInputTargetEnum[keyof typeof BusinessFreeColumnValueInputTargetEnum];

/**
 * 商品CD,名(マスタから)取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface BusinessNameFromMasterResponse
 */
export interface BusinessNameFromMasterResponse {
    /**
     * 
     * @type {number}
     * @memberof BusinessNameFromMasterResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BusinessNameFromMasterResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessNameFromMasterResponse
     */
    'message': string;
    /**
     * 
     * @type {BusinessNameFromMasterResponseAllOfResult}
     * @memberof BusinessNameFromMasterResponse
     */
    'result': BusinessNameFromMasterResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface BusinessNameFromMasterResponseAllOfResult
 */
export interface BusinessNameFromMasterResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof BusinessNameFromMasterResponseAllOfResult
     */
    'businessNumbers': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BusinessNameFromMasterResponseAllOfResult
     */
    'businessNames': Array<string>;
}
/**
 * 商品名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface BusinessNameResponse
 */
export interface BusinessNameResponse {
    /**
     * 
     * @type {number}
     * @memberof BusinessNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BusinessNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessNameResponse
     */
    'message': string;
    /**
     * 
     * @type {BusinessNameResponseAllOfResult}
     * @memberof BusinessNameResponse
     */
    'result': BusinessNameResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface BusinessNameResponseAllOfResult
 */
export interface BusinessNameResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof BusinessNameResponseAllOfResult
     */
    'businessNames': Array<string>;
}
/**
 * 商品コード取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface BusinessNumberResponse
 */
export interface BusinessNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {BusinessNumberResponseAllOfResult}
     * @memberof BusinessNumberResponse
     */
    'result': BusinessNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface BusinessNumberResponseAllOfResult
 */
export interface BusinessNumberResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof BusinessNumberResponseAllOfResult
     */
    'businessNumbers': Array<string>;
}
/**
 * 客先内示日別情報
 * @export
 * @interface CustomerForecastDaily
 */
export interface CustomerForecastDaily {
    /**
     * 客先内示日別ID
     * @type {string}
     * @memberof CustomerForecastDaily
     */
    'customerForecastDailyId': string;
    /**
     * 客先内示受領年
     * @type {number}
     * @memberof CustomerForecastDaily
     */
    'customerForecastReceivedYear': number;
    /**
     * 客先内示受領月
     * @type {number}
     * @memberof CustomerForecastDaily
     */
    'customerForecastReceivedMonth': number;
    /**
     * 客先内示対象年
     * @type {number}
     * @memberof CustomerForecastDaily
     */
    'customerForecastTargetYear': number;
    /**
     * 客先内示対象月
     * @type {number}
     * @memberof CustomerForecastDaily
     */
    'customerForecastTargetMonth': number;
    /**
     * 客先内示対象日
     * @type {number}
     * @memberof CustomerForecastDaily
     */
    'customerForecastTargetDay': number;
    /**
     * 客先内示数量
     * @type {string}
     * @memberof CustomerForecastDaily
     */
    'customerForecastAmount': string;
}
/**
 * 客先内示サマリ情報
 * @export
 * @interface CustomerForecastSummary
 */
export interface CustomerForecastSummary {
    /**
     * 客先内示サマリID
     * @type {string}
     * @memberof CustomerForecastSummary
     */
    'customerForecastSummaryId': string;
    /**
     * 客先内示受領年
     * @type {number}
     * @memberof CustomerForecastSummary
     */
    'customerForecastReceivedYear': number;
    /**
     * 客先内示受領月
     * @type {number}
     * @memberof CustomerForecastSummary
     */
    'customerForecastReceivedMonth': number;
    /**
     * 客先内示対象年
     * @type {number}
     * @memberof CustomerForecastSummary
     */
    'customerForecastTargetYear': number;
    /**
     * 客先内示対象月
     * @type {number}
     * @memberof CustomerForecastSummary
     */
    'customerForecastTargetMonth': number;
    /**
     * 客先内示数量
     * @type {string}
     * @memberof CustomerForecastSummary
     */
    'customerForecastAmountTotal': string;
}
/**
 * 重複が確認された集計が持っているリードタイムなどの情報群
 * @export
 * @interface DifferenceAggregateBusinessSubInfo
 */
export interface DifferenceAggregateBusinessSubInfo {
    /**
     * 容量の単位
     * @type {string}
     * @memberof DifferenceAggregateBusinessSubInfo
     */
    'unit': string;
    /**
     * 
     * @type {number}
     * @memberof DifferenceAggregateBusinessSubInfo
     */
    'moq': number;
    /**
     * リードタイム
     * @type {number}
     * @memberof DifferenceAggregateBusinessSubInfo
     */
    'leadTime': number;
    /**
     * リードタイムの単位
     * @type {string}
     * @memberof DifferenceAggregateBusinessSubInfo
     */
    'leadTimeUnit': string;
    /**
     * 国内輸送日数(In-transit days)
     * @type {number}
     * @memberof DifferenceAggregateBusinessSubInfo
     */
    'inTransitDays'?: number;
    /**
     * 標準在庫指数（MIN）
     * @type {number}
     * @memberof DifferenceAggregateBusinessSubInfo
     */
    'stdInventoryIndicesMin': number;
    /**
     * 標準在庫指数（MAX）
     * @type {number}
     * @memberof DifferenceAggregateBusinessSubInfo
     */
    'stdInventoryIndicesMax': number;
    /**
     * 標準在庫指数（単位）
     * @type {string}
     * @memberof DifferenceAggregateBusinessSubInfo
     */
    'stdInventoryIndicesUnit': string;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 指定したパラメータに対するAggregateBusiness、BaseBusinessが存在するかどうかを取得する場合に返却されるレスポンス
 * @export
 * @interface ExistsAggregateBusinessAndBaseBusiness
 */
export interface ExistsAggregateBusinessAndBaseBusiness {
    /**
     * 
     * @type {number}
     * @memberof ExistsAggregateBusinessAndBaseBusiness
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof ExistsAggregateBusinessAndBaseBusiness
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusiness
     */
    'message': string;
    /**
     * 
     * @type {ExistsAggregateBusinessAndBaseBusinessAllOfResult}
     * @memberof ExistsAggregateBusinessAndBaseBusiness
     */
    'result': ExistsAggregateBusinessAndBaseBusinessAllOfResult;
}
/**
 * 
 * @export
 * @interface ExistsAggregateBusinessAndBaseBusinessAllOfResult
 */
export interface ExistsAggregateBusinessAndBaseBusinessAllOfResult {
    /**
     * 重複する集計取引のID
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessAllOfResult
     */
    'aggregateBusinessId': string;
    /**
     * 重複する関連取引のID
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessAllOfResult
     */
    'baseBusinessId': string;
    /**
     * 集計と関連取引情報が存在する時に返す関連取引情報
     * @type {Array<ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData>}
     * @memberof ExistsAggregateBusinessAndBaseBusinessAllOfResult
     */
    'existsBusinessData': Array<ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData>;
}
/**
 * 指定したパラメータに対するAggregateBusiness、BaseBusinessが存在するかどうかを取得するAPIのパラメータの型
 * @export
 * @interface ExistsAggregateBusinessAndBaseBusinessParameters
 */
export interface ExistsAggregateBusinessAndBaseBusinessParameters {
    /**
     * 置場コード
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessParameters
     */
    'warehouseNumber': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessParameters
     */
    'supplierNumber': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessParameters
     */
    'businessNumber': string;
    /**
     * 容量
     * @type {number}
     * @memberof ExistsAggregateBusinessAndBaseBusinessParameters
     */
    'package': number;
    /**
     * 売上先コード
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessParameters
     */
    'customerNumber': string;
    /**
     * 送り先コード
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessParameters
     */
    'salesDestinationNumber': string;
}
/**
 * 集計と関連取引情報の存在確認APIで、集計と関連取引がどちらも存在していた時に返す関連取引情報一覧
 * @export
 * @interface ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
 */
export interface ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData {
    /**
     * 集計ID
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'aggregateBusinessId': string;
    /**
     * 置場CD
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'warehouse': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'supplierName': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'businessName': string;
    /**
     * 容量
     * @type {number}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'package': number;
    /**
     * 関連取引ID
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'baseBusinessId': string;
    /**
     * 客先CD
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'customerNumber': string;
    /**
     * 客先名
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'customerName': string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'salesDestinationNumber': string;
    /**
     * 送り先名
     * @type {string}
     * @memberof ExistsAggregateBusinessAndBaseBusinessResponseExistsBusinessDataData
     */
    'salesDestinationName': string;
}
/**
 * 指定したパラメータに対するAggregateBusinessが存在するかどうかを取得するAPIのパラメータの型
 * @export
 * @interface ExistsAggregateBusinessParameters
 */
export interface ExistsAggregateBusinessParameters {
    /**
     * 置場コード
     * @type {string}
     * @memberof ExistsAggregateBusinessParameters
     */
    'warehouseNumber': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof ExistsAggregateBusinessParameters
     */
    'supplierNumber': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof ExistsAggregateBusinessParameters
     */
    'businessNumber': string;
    /**
     * 容量
     * @type {number}
     * @memberof ExistsAggregateBusinessParameters
     */
    'package': number;
    /**
     * 容量の単位
     * @type {string}
     * @memberof ExistsAggregateBusinessParameters
     */
    'unit'?: string;
    /**
     * リードタイム
     * @type {number}
     * @memberof ExistsAggregateBusinessParameters
     */
    'leadTime'?: number;
    /**
     * リードタイムの単位
     * @type {string}
     * @memberof ExistsAggregateBusinessParameters
     */
    'leadTimeUnit'?: string;
    /**
     * 国内輸送日数(In-transit days)
     * @type {number}
     * @memberof ExistsAggregateBusinessParameters
     */
    'inTransitDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExistsAggregateBusinessParameters
     */
    'moq'?: number;
    /**
     * 標準在庫指数 (最小)
     * @type {number}
     * @memberof ExistsAggregateBusinessParameters
     */
    'stdInventoryIndicesMin'?: number;
    /**
     * 標準在庫指数 (最大)
     * @type {number}
     * @memberof ExistsAggregateBusinessParameters
     */
    'stdInventoryIndicesMax'?: number;
    /**
     * 標準在庫指数 (単位)
     * @type {string}
     * @memberof ExistsAggregateBusinessParameters
     */
    'stdInventoryIndicesUnit'?: string;
}
/**
 * 指定したBusinessIdに関連するAggregateBusinessが存在する場合に返却されるレスポンス
 * @export
 * @interface ExistsAggregateBusinessSuccess
 */
export interface ExistsAggregateBusinessSuccess {
    /**
     * 
     * @type {number}
     * @memberof ExistsAggregateBusinessSuccess
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof ExistsAggregateBusinessSuccess
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ExistsAggregateBusinessSuccess
     */
    'message': string;
    /**
     * 
     * @type {ExistsAggregateBusinessSuccessAllOfResult}
     * @memberof ExistsAggregateBusinessSuccess
     */
    'result': ExistsAggregateBusinessSuccessAllOfResult;
}
/**
 * 
 * @export
 * @interface ExistsAggregateBusinessSuccessAllOfResult
 */
export interface ExistsAggregateBusinessSuccessAllOfResult {
    /**
     * 集計ID
     * @type {string}
     * @memberof ExistsAggregateBusinessSuccessAllOfResult
     */
    'aggregateBusinessId'?: string;
    /**
     * 集計取引の副次的情報に差分があるかどうか(現状、リードタイム、標準在庫指数、容量の単位について)
     * @type {boolean}
     * @memberof ExistsAggregateBusinessSuccessAllOfResult
     */
    'hasDifferenceAggregateBusinessSubInfo': boolean;
    /**
     * 
     * @type {DifferenceAggregateBusinessSubInfo}
     * @memberof ExistsAggregateBusinessSuccessAllOfResult
     */
    'differenceAggregateBusinessSubInfo'?: DifferenceAggregateBusinessSubInfo;
}
/**
 * 客先内示/販売実績の集計情報の過去実績一覧を取得するAPIのレスポンスで返ってくるデータの型
 * @export
 * @interface ForecastAccuracyHistoryFromSummaryDataResponse
 */
export interface ForecastAccuracyHistoryFromSummaryDataResponse {
    /**
     * 
     * @type {number}
     * @memberof ForecastAccuracyHistoryFromSummaryDataResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastAccuracyHistoryFromSummaryDataResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ForecastAccuracyHistoryFromSummaryDataResponse
     */
    'message': string;
    /**
     * 
     * @type {GetForecastAccuracyHistoryFromSummaryDataResult}
     * @memberof ForecastAccuracyHistoryFromSummaryDataResponse
     */
    'result': GetForecastAccuracyHistoryFromSummaryDataResult;
}
/**
 * 
 * @export
 * @interface GetAggregateBusinessSuccessResponse
 */
export interface GetAggregateBusinessSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetAggregateBusinessSuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetAggregateBusinessSuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetAggregateBusinessSuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {GetAggregateBusinessSuccessResponseAllOfResult}
     * @memberof GetAggregateBusinessSuccessResponse
     */
    'result': GetAggregateBusinessSuccessResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetAggregateBusinessSuccessResponseAllOfResult
 */
export interface GetAggregateBusinessSuccessResponseAllOfResult {
    /**
     * 
     * @type {AggregateBusiness}
     * @memberof GetAggregateBusinessSuccessResponseAllOfResult
     */
    'aggregateBusiness'?: AggregateBusiness;
}
/**
 * 客先内示/販売実績の集計情報の過去実績一覧を取得するAPIのレスポンスの型定義
 * @export
 * @interface GetForecastAccuracyHistoryFromSummaryDataResult
 */
export interface GetForecastAccuracyHistoryFromSummaryDataResult {
    /**
     * 客先内示サマリの過去実績一覧
     * @type {Array<CustomerForecastSummary>}
     * @memberof GetForecastAccuracyHistoryFromSummaryDataResult
     */
    'customerForecastSummaryHistory': Array<CustomerForecastSummary>;
    /**
     * 販売実績サマリの過去実績一覧
     * @type {Array<SalesResultSummary>}
     * @memberof GetForecastAccuracyHistoryFromSummaryDataResult
     */
    'salesResultSummaryHistory': Array<SalesResultSummary>;
}
/**
 * 
 * @export
 * @interface GetFreeColumnValuesResponse
 */
export interface GetFreeColumnValuesResponse {
    /**
     * 
     * @type {number}
     * @memberof GetFreeColumnValuesResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetFreeColumnValuesResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetFreeColumnValuesResponse
     */
    'message': string;
    /**
     * 
     * @type {Array<GetFreeColumnValuesResponseAllOfResult>}
     * @memberof GetFreeColumnValuesResponse
     */
    'result': Array<GetFreeColumnValuesResponseAllOfResult>;
}
/**
 * 
 * @export
 * @interface GetFreeColumnValuesResponseAllOfResult
 */
export interface GetFreeColumnValuesResponseAllOfResult {
    /**
     * 
     * @type {number}
     * @memberof GetFreeColumnValuesResponseAllOfResult
     */
    'columnIndex': number;
    /**
     * 
     * @type {string}
     * @memberof GetFreeColumnValuesResponseAllOfResult
     */
    'headerName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFreeColumnValuesResponseAllOfResult
     */
    'values': Array<string>;
}
/**
 * 集計のシミュレーションをするAPIのレスポンスの型定義
 * @export
 * @interface GetSimulatedAggregateBusinessInfo
 */
export interface GetSimulatedAggregateBusinessInfo {
    /**
     * 集計ID
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'aggregateBusinessId': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'supplierName': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'businessName': string;
    /**
     * 容量
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'package': string;
    /**
     * 倉庫
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'warehouse': string;
    /**
     * 単位
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'unit': string;
    /**
     * 標準在庫指数（下限）
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'stdInventoryIndicesMin': string;
    /**
     * 標準在庫指数（上限）
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'stdInventoryIndicesMax': string;
    /**
     * 標準在庫指数の単位
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'stdInventoryIndicesUnit': string;
    /**
     * リードタイム
     * @type {number}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'leadTime': number;
    /**
     * リードタイムの単位
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'leadTimeUnit': string;
    /**
     * 国内輸送日数(In-transit days)
     * @type {number}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'inTransitDays'?: number;
    /**
     * 最小発注数量
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'moq'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'manufacturer'?: string;
    /**
     * 発注単位
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'orderPackage': string;
    /**
     * 集計メモ
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'aggregateBusinessNote'?: string;
    /**
     * 在庫年月日
     * @type {number}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'executionDate': number;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'aggregateBusinessResponsibleUsers': Array<UserData>;
    /**
     * 集計取引の自由欄値
     * @type {Array<BusinessFreeColumnValue>}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValue>;
    /**
     * 
     * @type {UserData}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'lastCheckedUser'?: UserData;
    /**
     * 最後に集計をチェックした日時
     * @type {number}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'lastCheckedAt'?: number;
    /**
     * 入荷情報
     * @type {Array<Arrival>}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'arrivals'?: Array<Arrival>;
    /**
     * 発注情報
     * @type {Array<Order>}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'orders'?: Array<Order>;
    /**
     * 販売実績情報
     * @type {Array<SalesResultSummary>}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'salesResults'?: Array<SalesResultSummary>;
    /**
     * 在庫情報
     * @type {Array<Inventory>}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'inventories'?: Array<Inventory>;
    /**
     * 客先内示情報
     * @type {Array<CustomerForecastSummary>}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'customerForecasts'?: Array<CustomerForecastSummary>;
    /**
     * 客先内示日別情報
     * @type {Array<CustomerForecastDaily>}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'customerForecastsDaily'?: Array<CustomerForecastDaily>;
    /**
     * 仕入先内示情報
     * @type {Array<SupplierForecast>}
     * @memberof GetSimulatedAggregateBusinessInfo
     */
    'supplierForecasts'?: Array<SupplierForecast>;
}
/**
 * 集計のシミュレーションをするAPIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetSimulatedAggregateBusinessResponse
 */
export interface GetSimulatedAggregateBusinessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSimulatedAggregateBusinessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetSimulatedAggregateBusinessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSimulatedAggregateBusinessResponse
     */
    'message': string;
    /**
     * 
     * @type {GetSimulatedAggregateBusinessResponseResult}
     * @memberof GetSimulatedAggregateBusinessResponse
     */
    'result': GetSimulatedAggregateBusinessResponseResult;
}
/**
 * 集計のシミュレーションをするAPIのレスポンスの型定義
 * @export
 * @interface GetSimulatedAggregateBusinessResponseResult
 */
export interface GetSimulatedAggregateBusinessResponseResult {
    /**
     * 
     * @type {GetSimulatedAggregateBusinessInfo}
     * @memberof GetSimulatedAggregateBusinessResponseResult
     */
    'simulatedAggregateBusiness': GetSimulatedAggregateBusinessInfo;
}
/**
 * 在庫情報
 * @export
 * @interface Inventory
 */
export interface Inventory {
    /**
     * 在庫ID
     * @type {string}
     * @memberof Inventory
     */
    'inventoryId': string;
    /**
     * 在庫年
     * @type {number}
     * @memberof Inventory
     */
    'inventoriedTargetYear': number;
    /**
     * 在庫月
     * @type {number}
     * @memberof Inventory
     */
    'inventoriedTargetMonth': number;
    /**
     * 在庫数量
     * @type {string}
     * @memberof Inventory
     */
    'inventoryAmount': string;
}
/**
 * 
 * @export
 * @interface LeadTimeAggregateBusinessIdPutRequest
 */
export interface LeadTimeAggregateBusinessIdPutRequest {
    /**
     * 
     * @type {PutLeadTimeRequestInfo}
     * @memberof LeadTimeAggregateBusinessIdPutRequest
     */
    'putLeadTimeRequestInfo': PutLeadTimeRequestInfo;
}
/**
 * リードタイム情報
 * @export
 * @interface LeadTimeInfo
 */
export interface LeadTimeInfo {
    /**
     * 
     * @type {number}
     * @memberof LeadTimeInfo
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof LeadTimeInfo
     */
    'unit'?: string;
}
/**
 * リードタイム取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface LeadTimeResponse
 */
export interface LeadTimeResponse {
    /**
     * 
     * @type {number}
     * @memberof LeadTimeResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof LeadTimeResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof LeadTimeResponse
     */
    'message': string;
    /**
     * 
     * @type {LeadTimeResponseAllOfResult}
     * @memberof LeadTimeResponse
     */
    'result': LeadTimeResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface LeadTimeResponseAllOfResult
 */
export interface LeadTimeResponseAllOfResult {
    /**
     * 
     * @type {Array<LeadTimeInfo>}
     * @memberof LeadTimeResponseAllOfResult
     */
    'leadTimes': Array<LeadTimeInfo>;
}
/**
 * 製造社取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface ManufacturerResponse
 */
export interface ManufacturerResponse {
    /**
     * 
     * @type {number}
     * @memberof ManufacturerResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturerResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ManufacturerResponse
     */
    'message': string;
    /**
     * 
     * @type {ManufacturerResponseAllOfResult}
     * @memberof ManufacturerResponse
     */
    'result': ManufacturerResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface ManufacturerResponseAllOfResult
 */
export interface ManufacturerResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof ManufacturerResponseAllOfResult
     */
    'manufacturers': Array<string>;
}
/**
 * 
 * @export
 * @interface MoqAggregateBusinessIdPutRequest
 */
export interface MoqAggregateBusinessIdPutRequest {
    /**
     * MOQ
     * @type {number}
     * @memberof MoqAggregateBusinessIdPutRequest
     */
    'moq': number;
}
/**
 * MOQ取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface MoqResponse
 */
export interface MoqResponse {
    /**
     * 
     * @type {number}
     * @memberof MoqResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof MoqResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof MoqResponse
     */
    'message': string;
    /**
     * 
     * @type {MoqResponseAllOfResult}
     * @memberof MoqResponse
     */
    'result': MoqResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface MoqResponseAllOfResult
 */
export interface MoqResponseAllOfResult {
    /**
     * 
     * @type {Array<number>}
     * @memberof MoqResponseAllOfResult
     */
    'moqs': Array<number>;
}
/**
 * 発注情報
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 集計ID
     * @type {string}
     * @memberof Order
     */
    'aggregateBusinessId'?: string;
    /**
     * 発注ID
     * @type {string}
     * @memberof Order
     */
    'orderId': string;
    /**
     * 発注番号
     * @type {string}
     * @memberof Order
     */
    'orderNumber': string;
    /**
     * 発注作成日
     * @type {number}
     * @memberof Order
     */
    'createdOrderDate'?: number;
    /**
     * 入荷予定日
     * @type {number}
     * @memberof Order
     */
    'estimatedTimeOfArrival': number;
    /**
     * 発注数量
     * @type {string}
     * @memberof Order
     */
    'orderAmount': string;
    /**
     * 発注ステータス
     * @type {string}
     * @memberof Order
     */
    'orderStatus': string;
    /**
     * 発注メモ
     * @type {string}
     * @memberof Order
     */
    'orderNote'?: string;
    /**
     * 発注グループID
     * @type {string}
     * @memberof Order
     */
    'orderGroupId'?: string;
    /**
     * 発注グループ名
     * @type {string}
     * @memberof Order
     */
    'orderGroupName'?: string;
    /**
     * 上限発注数量(発注グループ)
     * @type {string}
     * @memberof Order
     */
    'upperLimitQuantity'?: string;
    /**
     * リマインドメールデータID
     * @type {string}
     * @memberof Order
     */
    'reminderMailDataId'?: string;
    /**
     * 更新日時
     * @type {number}
     * @memberof Order
     */
    'updateAt'?: number;
    /**
     * 分納情報一覧
     * @type {Array<PartialDelivery>}
     * @memberof Order
     */
    'partialDeliveries'?: Array<PartialDelivery>;
}
/**
 * 
 * @export
 * @interface OrderPackageAggregateBusinessIdPutRequest
 */
export interface OrderPackageAggregateBusinessIdPutRequest {
    /**
     * 発注単位
     * @type {number}
     * @memberof OrderPackageAggregateBusinessIdPutRequest
     */
    'orderPackage': number;
}
/**
 * 発注単位取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface OrderPackageResponse
 */
export interface OrderPackageResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderPackageResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof OrderPackageResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof OrderPackageResponse
     */
    'message': string;
    /**
     * 
     * @type {OrderPackageResponseAllOfResult}
     * @memberof OrderPackageResponse
     */
    'result': OrderPackageResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface OrderPackageResponseAllOfResult
 */
export interface OrderPackageResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderPackageResponseAllOfResult
     */
    'orderPackages': Array<string>;
}
/**
 * 容量取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface PackageResponse
 */
export interface PackageResponse {
    /**
     * 
     * @type {number}
     * @memberof PackageResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PackageResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PackageResponse
     */
    'message': string;
    /**
     * 
     * @type {PackageResponseAllOfResult}
     * @memberof PackageResponse
     */
    'result': PackageResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface PackageResponseAllOfResult
 */
export interface PackageResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof PackageResponseAllOfResult
     */
    'packages': Array<string>;
}
/**
 * 分納情報
 * @export
 * @interface PartialDelivery
 */
export interface PartialDelivery {
    /**
     * 分納ID
     * @type {string}
     * @memberof PartialDelivery
     */
    'orderId': string;
    /**
     * 発注ID
     * @type {string}
     * @memberof PartialDelivery
     */
    'partialDeliveryId': string;
    /**
     * 分納番号
     * @type {string}
     * @memberof PartialDelivery
     */
    'partialDeliveryNumber'?: string;
    /**
     * 分納情報作成日
     * @type {number}
     * @memberof PartialDelivery
     */
    'createdPartialDeliveryDate': number;
    /**
     * 分納予定日
     * @type {number}
     * @memberof PartialDelivery
     */
    'partialDeliveryEstimatedTimeOfArrival': number;
    /**
     * 分納数量
     * @type {string}
     * @memberof PartialDelivery
     */
    'partialDeliveryAmount': string;
    /**
     * 分納ステータス
     * @type {string}
     * @memberof PartialDelivery
     */
    'partialDeliveryState': string;
    /**
     * 更新日時
     * @type {number}
     * @memberof PartialDelivery
     */
    'updateAt'?: number;
}
/**
 * 
 * @export
 * @interface PostAggregateBusinessRequestInfo
 */
export interface PostAggregateBusinessRequestInfo {
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'supplierNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'businessNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'package': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'warehouse': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'warehouseNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'unit': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'manufacturer'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'stdInventoryIndicesMin': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'stdInventoryIndicesMax': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'stdInventoryIndicesUnit': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'leadTime': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'leadTimeUnit': string;
    /**
     * 国内輸送日数(In-transit days)
     * @type {number}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'inTransitDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'moq'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'orderPackage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'executionDate': string;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'aggregateBusinessNote'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'aggregateBusinessResponsibleUserIdList': Array<string>;
    /**
     * 
     * @type {Array<BusinessFreeColumnValueInput>}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValueInput>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostAggregateBusinessRequestInfo
     */
    'placeholderFields'?: Array<string>;
}
/**
 * 集計登録APIのレスポンスで返ってくるデータの型
 * @export
 * @interface PostAggregateBusinessResponse
 */
export interface PostAggregateBusinessResponse {
    /**
     * 
     * @type {number}
     * @memberof PostAggregateBusinessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostAggregateBusinessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessResponse
     */
    'message': string;
    /**
     * 
     * @type {PostAggregateBusinessResponseResult}
     * @memberof PostAggregateBusinessResponse
     */
    'result': PostAggregateBusinessResponseResult;
}
/**
 * 集計登録APIのレスポンスの型定義
 * @export
 * @interface PostAggregateBusinessResponseResult
 */
export interface PostAggregateBusinessResponseResult {
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessResponseResult
     */
    'aggregateBusinessId': string;
}
/**
 * 仕入単価取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface PurchaseUnitPriceResponse
 */
export interface PurchaseUnitPriceResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseUnitPriceResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseUnitPriceResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseUnitPriceResponse
     */
    'message': string;
    /**
     * 
     * @type {PurchaseUnitPriceResponseAllOfResult}
     * @memberof PurchaseUnitPriceResponse
     */
    'result': PurchaseUnitPriceResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface PurchaseUnitPriceResponseAllOfResult
 */
export interface PurchaseUnitPriceResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof PurchaseUnitPriceResponseAllOfResult
     */
    'purchaseUnitPrices': Array<string>;
}
/**
 * 集計情報の編集を行うAPIのリクエストの型
 * @export
 * @interface PutAggregateBusinessRequestInfo
 */
export interface PutAggregateBusinessRequestInfo {
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'warehouse': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'warehouseNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'supplierNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'businessName': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'businessNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'package': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'manufacturer'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'stdInventoryIndicesMin': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'stdInventoryIndicesMax': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'stdInventoryIndicesUnit': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'leadTime': string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'leadTimeUnit': string;
    /**
     * 国内輸送日数(In-transit days)
     * @type {number}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'inTransitDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'moq'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'orderPackage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'purchaseUnitPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'userUniqueNumber'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'aggregateBusinessResponsibleUserIdList': Array<string>;
    /**
     * 
     * @type {Array<BusinessFreeColumnValueInput>}
     * @memberof PutAggregateBusinessRequestInfo
     */
    'businessFreeColumnValues'?: Array<BusinessFreeColumnValueInput>;
}
/**
 * 最終チェック情報更新APIのレスポンスで帰ってくるデータの型
 * @export
 * @interface PutLastCheckedResponse
 */
export interface PutLastCheckedResponse {
    /**
     * 
     * @type {number}
     * @memberof PutLastCheckedResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PutLastCheckedResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PutLastCheckedResponse
     */
    'message': string;
    /**
     * 
     * @type {PutLastCheckedResponseAllOfResult}
     * @memberof PutLastCheckedResponse
     */
    'result': PutLastCheckedResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface PutLastCheckedResponseAllOfResult
 */
export interface PutLastCheckedResponseAllOfResult {
    /**
     * 更新した集計ID
     * @type {string}
     * @memberof PutLastCheckedResponseAllOfResult
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {UserData}
     * @memberof PutLastCheckedResponseAllOfResult
     */
    'lastCheckedUser': UserData;
    /**
     * 更新した日時
     * @type {number}
     * @memberof PutLastCheckedResponseAllOfResult
     */
    'lastCheckedAt': number;
}
/**
 * リードタイムを更新する際のリクエストの型
 * @export
 * @interface PutLeadTimeRequestInfo
 */
export interface PutLeadTimeRequestInfo {
    /**
     * リードタイム
     * @type {number}
     * @memberof PutLeadTimeRequestInfo
     */
    'leadTime': number;
    /**
     * リードタイムの単位
     * @type {string}
     * @memberof PutLeadTimeRequestInfo
     */
    'leadTimeUnit': string;
    /**
     * 国内輸送日数(In-transit days)
     * @type {number}
     * @memberof PutLeadTimeRequestInfo
     */
    'inTransitDays'?: number;
}
/**
 * 標準在庫指数を更新する際のリクエストの型
 * @export
 * @interface PutStdInventoryIndicesRequestInfo
 */
export interface PutStdInventoryIndicesRequestInfo {
    /**
     * 標準在庫指数（MIN）
     * @type {number}
     * @memberof PutStdInventoryIndicesRequestInfo
     */
    'stdInventoryIndicesMin': number;
    /**
     * 標準在庫指数（MAX）
     * @type {number}
     * @memberof PutStdInventoryIndicesRequestInfo
     */
    'stdInventoryIndicesMax': number;
    /**
     * 標準在庫指数（単位）
     * @type {string}
     * @memberof PutStdInventoryIndicesRequestInfo
     */
    'stdInventoryIndicesUnit': string;
}
/**
 * 販売実績サマリ
 * @export
 * @interface SalesResultSummary
 */
export interface SalesResultSummary {
    /**
     * 販売実績サマリID
     * @type {string}
     * @memberof SalesResultSummary
     */
    'salesResultSummaryId': string;
    /**
     * 販売実績対象年
     * @type {number}
     * @memberof SalesResultSummary
     */
    'salesResultTargetYear': number;
    /**
     * 販売実績対象月
     * @type {number}
     * @memberof SalesResultSummary
     */
    'salesResultTargetMonth': number;
    /**
     * 販売数量
     * @type {string}
     * @memberof SalesResultSummary
     */
    'salesResultAmountTotal': string;
}
/**
 * 
 * @export
 * @interface StdInventoryIndicesAggregateBusinessIdPutRequest
 */
export interface StdInventoryIndicesAggregateBusinessIdPutRequest {
    /**
     * 
     * @type {PutStdInventoryIndicesRequestInfo}
     * @memberof StdInventoryIndicesAggregateBusinessIdPutRequest
     */
    'putStdInventoryIndicesRequestInfo': PutStdInventoryIndicesRequestInfo;
}
/**
 * 標準在庫指標情報(min, max別々の場合)
 * @export
 * @interface StdInventoryIndicesInfo
 */
export interface StdInventoryIndicesInfo {
    /**
     * 
     * @type {number}
     * @memberof StdInventoryIndicesInfo
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof StdInventoryIndicesInfo
     */
    'unit'?: string;
}
/**
 * 標準在庫指数(最大)取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface StdInventoryIndicesMaxResponse
 */
export interface StdInventoryIndicesMaxResponse {
    /**
     * 
     * @type {number}
     * @memberof StdInventoryIndicesMaxResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof StdInventoryIndicesMaxResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof StdInventoryIndicesMaxResponse
     */
    'message': string;
    /**
     * 
     * @type {StdInventoryIndicesMaxResponseAllOfResult}
     * @memberof StdInventoryIndicesMaxResponse
     */
    'result': StdInventoryIndicesMaxResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface StdInventoryIndicesMaxResponseAllOfResult
 */
export interface StdInventoryIndicesMaxResponseAllOfResult {
    /**
     * 
     * @type {Array<StdInventoryIndicesInfo>}
     * @memberof StdInventoryIndicesMaxResponseAllOfResult
     */
    'stdInventoryIndicesMaxes': Array<StdInventoryIndicesInfo>;
}
/**
 * 標準在庫指数(最小)取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface StdInventoryIndicesMinResponse
 */
export interface StdInventoryIndicesMinResponse {
    /**
     * 
     * @type {number}
     * @memberof StdInventoryIndicesMinResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof StdInventoryIndicesMinResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof StdInventoryIndicesMinResponse
     */
    'message': string;
    /**
     * 
     * @type {StdInventoryIndicesMinResponseAllOfResult}
     * @memberof StdInventoryIndicesMinResponse
     */
    'result': StdInventoryIndicesMinResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface StdInventoryIndicesMinResponseAllOfResult
 */
export interface StdInventoryIndicesMinResponseAllOfResult {
    /**
     * 
     * @type {Array<StdInventoryIndicesInfo>}
     * @memberof StdInventoryIndicesMinResponseAllOfResult
     */
    'stdInventoryIndicesMins': Array<StdInventoryIndicesInfo>;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 仕入先内示情報
 * @export
 * @interface SupplierForecast
 */
export interface SupplierForecast {
    /**
     * 仕入先内示ID
     * @type {string}
     * @memberof SupplierForecast
     */
    'supplierForecastId': string;
    /**
     * 仕入先内示作成年
     * @type {number}
     * @memberof SupplierForecast
     */
    'supplierForecastCreatedYear': number;
    /**
     * 仕入先内示作成月
     * @type {number}
     * @memberof SupplierForecast
     */
    'supplierForecastCreatedMonth': number;
    /**
     * 仕入先内示対象年
     * @type {number}
     * @memberof SupplierForecast
     */
    'supplierForecastTargetYear': number;
    /**
     * 仕入先内示対象月
     * @type {number}
     * @memberof SupplierForecast
     */
    'supplierForecastTargetMonth': number;
    /**
     * 仕入先内示数量
     * @type {string}
     * @memberof SupplierForecast
     */
    'supplierForecastAmount': string;
    /**
     * 仕入先内示と客先内示がイコールかどうか
     * @type {boolean}
     * @memberof SupplierForecast
     */
    'equalCustomerForecastDataFlag'?: boolean;
}
/**
 * 仕入先CD,名(マスタから)取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface SupplierNameFromMasterResponse
 */
export interface SupplierNameFromMasterResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierNameFromMasterResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierNameFromMasterResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierNameFromMasterResponse
     */
    'message': string;
    /**
     * 
     * @type {SupplierNameFromMasterResponseAllOfResult}
     * @memberof SupplierNameFromMasterResponse
     */
    'result': SupplierNameFromMasterResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface SupplierNameFromMasterResponseAllOfResult
 */
export interface SupplierNameFromMasterResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierNameFromMasterResponseAllOfResult
     */
    'supplierNumbers': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierNameFromMasterResponseAllOfResult
     */
    'supplierNames': Array<string>;
}
/**
 * 仕入先名取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface SupplierNameResponse
 */
export interface SupplierNameResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierNameResponse
     */
    'message': string;
    /**
     * 
     * @type {SupplierNameResponseAllOfResult}
     * @memberof SupplierNameResponse
     */
    'result': SupplierNameResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface SupplierNameResponseAllOfResult
 */
export interface SupplierNameResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierNameResponseAllOfResult
     */
    'supplierNames': Array<string>;
}
/**
 * 仕入先CD取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface SupplierNumberResponse
 */
export interface SupplierNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SupplierNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {SupplierNumberResponseAllOfResult}
     * @memberof SupplierNumberResponse
     */
    'result': SupplierNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface SupplierNumberResponseAllOfResult
 */
export interface SupplierNumberResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplierNumberResponseAllOfResult
     */
    'supplierNumbers': Array<string>;
}
/**
 * 単位取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface UnitResponse
 */
export interface UnitResponse {
    /**
     * 
     * @type {number}
     * @memberof UnitResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UnitResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UnitResponse
     */
    'message': string;
    /**
     * 
     * @type {UnitResponseAllOfResult}
     * @memberof UnitResponse
     */
    'result': UnitResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface UnitResponseAllOfResult
 */
export interface UnitResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof UnitResponseAllOfResult
     */
    'units': Array<string>;
}
/**
 * ユーザーデータ
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string;
}
/**
 * 倉庫CD,名(マスタから)取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface WarehouseFromMasterResponse
 */
export interface WarehouseFromMasterResponse {
    /**
     * 
     * @type {number}
     * @memberof WarehouseFromMasterResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseFromMasterResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseFromMasterResponse
     */
    'message': string;
    /**
     * 
     * @type {WarehouseFromMasterResponseAllOfResult}
     * @memberof WarehouseFromMasterResponse
     */
    'result': WarehouseFromMasterResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface WarehouseFromMasterResponseAllOfResult
 */
export interface WarehouseFromMasterResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof WarehouseFromMasterResponseAllOfResult
     */
    'warehouseNumbers': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WarehouseFromMasterResponseAllOfResult
     */
    'warehouses': Array<string>;
}
/**
 * 倉庫CD取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface WarehouseNumberResponse
 */
export interface WarehouseNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof WarehouseNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {WarehouseNumberResponseAllOfResult}
     * @memberof WarehouseNumberResponse
     */
    'result': WarehouseNumberResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface WarehouseNumberResponseAllOfResult
 */
export interface WarehouseNumberResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof WarehouseNumberResponseAllOfResult
     */
    'warehouseNumbers': Array<string>;
}
/**
 * 倉庫取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface WarehouseResponse
 */
export interface WarehouseResponse {
    /**
     * 
     * @type {number}
     * @memberof WarehouseResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseResponse
     */
    'message': string;
    /**
     * 
     * @type {WarehouseResponseAllOfResult}
     * @memberof WarehouseResponse
     */
    'result': WarehouseResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface WarehouseResponseAllOfResult
 */
export interface WarehouseResponseAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof WarehouseResponseAllOfResult
     */
    'warehouses': Array<string>;
}

/**
 * AggregateBusinessApi - axios parameter creator
 * @export
 */
export const AggregateBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計テーブルの情報を一括変更する
         * @param {AggregateBusinessBulkPutRequest} aggregateBusinessBulkPutRequest 変更する集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessBulkPut: async (aggregateBusinessBulkPutRequest: AggregateBusinessBulkPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessBulkPutRequest' is not null or undefined
            assertParamExists('aggregateBusinessBulkPut', 'aggregateBusinessBulkPutRequest', aggregateBusinessBulkPutRequest)
            const localVarPath = `/aggregate-business/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggregateBusinessBulkPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 集計テーブルの情報を1件取得する
         * @param {string} [aggregateBusinessId] 集計ID
         * @param {AggregateBusinessGetUniqueKeysParameter} [uniqueKeys] UK必須キー集合
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessGet: async (aggregateBusinessId?: string, uniqueKeys?: AggregateBusinessGetUniqueKeysParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/aggregate-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aggregateBusinessId !== undefined) {
                localVarQueryParameter['aggregateBusinessId'] = aggregateBusinessId;
            }

            if (uniqueKeys !== undefined) {
                for (const [key, value] of Object.entries(uniqueKeys)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 集計テーブルに情報を登録する
         * @param {AggregateBusinessPostRequest} aggregateBusinessPostRequest 登録する集計テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessPost: async (aggregateBusinessPostRequest: AggregateBusinessPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessPostRequest' is not null or undefined
            assertParamExists('aggregateBusinessPost', 'aggregateBusinessPostRequest', aggregateBusinessPostRequest)
            const localVarPath = `/aggregate-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggregateBusinessPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 集計テーブルの情報を編集する
         * @param {AggregateBusinessPutRequest} aggregateBusinessPutRequest 編集する集計テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessPut: async (aggregateBusinessPutRequest: AggregateBusinessPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessPutRequest' is not null or undefined
            assertParamExists('aggregateBusinessPut', 'aggregateBusinessPutRequest', aggregateBusinessPutRequest)
            const localVarPath = `/aggregate-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggregateBusinessPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AggregateBusinessApi - functional programming interface
 * @export
 */
export const AggregateBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AggregateBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計テーブルの情報を一括変更する
         * @param {AggregateBusinessBulkPutRequest} aggregateBusinessBulkPutRequest 変更する集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessBulkPut(aggregateBusinessBulkPutRequest: AggregateBusinessBulkPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessBulkPut(aggregateBusinessBulkPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessApi.aggregateBusinessBulkPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 集計テーブルの情報を1件取得する
         * @param {string} [aggregateBusinessId] 集計ID
         * @param {AggregateBusinessGetUniqueKeysParameter} [uniqueKeys] UK必須キー集合
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessGet(aggregateBusinessId?: string, uniqueKeys?: AggregateBusinessGetUniqueKeysParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAggregateBusinessSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessGet(aggregateBusinessId, uniqueKeys, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessApi.aggregateBusinessGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 集計テーブルに情報を登録する
         * @param {AggregateBusinessPostRequest} aggregateBusinessPostRequest 登録する集計テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessPost(aggregateBusinessPostRequest: AggregateBusinessPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAggregateBusinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessPost(aggregateBusinessPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessApi.aggregateBusinessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 集計テーブルの情報を編集する
         * @param {AggregateBusinessPutRequest} aggregateBusinessPutRequest 編集する集計テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessPut(aggregateBusinessPutRequest: AggregateBusinessPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessPut(aggregateBusinessPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessApi.aggregateBusinessPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AggregateBusinessApi - factory interface
 * @export
 */
export const AggregateBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AggregateBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計テーブルの情報を一括変更する
         * @param {AggregateBusinessBulkPutRequest} aggregateBusinessBulkPutRequest 変更する集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessBulkPut(aggregateBusinessBulkPutRequest: AggregateBusinessBulkPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.aggregateBusinessBulkPut(aggregateBusinessBulkPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 集計テーブルの情報を1件取得する
         * @param {string} [aggregateBusinessId] 集計ID
         * @param {AggregateBusinessGetUniqueKeysParameter} [uniqueKeys] UK必須キー集合
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessGet(aggregateBusinessId?: string, uniqueKeys?: AggregateBusinessGetUniqueKeysParameter, options?: any): AxiosPromise<GetAggregateBusinessSuccessResponse> {
            return localVarFp.aggregateBusinessGet(aggregateBusinessId, uniqueKeys, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 集計テーブルに情報を登録する
         * @param {AggregateBusinessPostRequest} aggregateBusinessPostRequest 登録する集計テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessPost(aggregateBusinessPostRequest: AggregateBusinessPostRequest, options?: any): AxiosPromise<PostAggregateBusinessResponse> {
            return localVarFp.aggregateBusinessPost(aggregateBusinessPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 集計テーブルの情報を編集する
         * @param {AggregateBusinessPutRequest} aggregateBusinessPutRequest 編集する集計テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessPut(aggregateBusinessPutRequest: AggregateBusinessPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.aggregateBusinessPut(aggregateBusinessPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AggregateBusinessApi - object-oriented interface
 * @export
 * @class AggregateBusinessApi
 * @extends {BaseAPI}
 */
export class AggregateBusinessApi extends BaseAPI {
    /**
     * 
     * @summary 集計テーブルの情報を一括変更する
     * @param {AggregateBusinessBulkPutRequest} aggregateBusinessBulkPutRequest 変更する集計情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessApi
     */
    public aggregateBusinessBulkPut(aggregateBusinessBulkPutRequest: AggregateBusinessBulkPutRequest, options?: RawAxiosRequestConfig) {
        return AggregateBusinessApiFp(this.configuration).aggregateBusinessBulkPut(aggregateBusinessBulkPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 集計テーブルの情報を1件取得する
     * @param {string} [aggregateBusinessId] 集計ID
     * @param {AggregateBusinessGetUniqueKeysParameter} [uniqueKeys] UK必須キー集合
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessApi
     */
    public aggregateBusinessGet(aggregateBusinessId?: string, uniqueKeys?: AggregateBusinessGetUniqueKeysParameter, options?: RawAxiosRequestConfig) {
        return AggregateBusinessApiFp(this.configuration).aggregateBusinessGet(aggregateBusinessId, uniqueKeys, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 集計テーブルに情報を登録する
     * @param {AggregateBusinessPostRequest} aggregateBusinessPostRequest 登録する集計テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessApi
     */
    public aggregateBusinessPost(aggregateBusinessPostRequest: AggregateBusinessPostRequest, options?: RawAxiosRequestConfig) {
        return AggregateBusinessApiFp(this.configuration).aggregateBusinessPost(aggregateBusinessPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 集計テーブルの情報を編集する
     * @param {AggregateBusinessPutRequest} aggregateBusinessPutRequest 編集する集計テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessApi
     */
    public aggregateBusinessPut(aggregateBusinessPutRequest: AggregateBusinessPutRequest, options?: RawAxiosRequestConfig) {
        return AggregateBusinessApiFp(this.configuration).aggregateBusinessPut(aggregateBusinessPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AggregateBusinessGroupFilterInfoApi - axios parameter creator
 * @export
 */
export const AggregateBusinessGroupFilterInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注グループ一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [orderPackage] 発注単位
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessGroupFilterInfoGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, orderPackage?: string, aggregateBusinessResponsibleUserId?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/aggregate-business-group-filter-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AggregateBusinessGroupFilterInfoApi - functional programming interface
 * @export
 */
export const AggregateBusinessGroupFilterInfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AggregateBusinessGroupFilterInfoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注グループ一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [orderPackage] 発注単位
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessGroupFilterInfoGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, orderPackage?: string, aggregateBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregateBusinessGroupFilterInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessGroupFilterInfoGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, orderPackage, aggregateBusinessResponsibleUserId, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessGroupFilterInfoApi.aggregateBusinessGroupFilterInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AggregateBusinessGroupFilterInfoApi - factory interface
 * @export
 */
export const AggregateBusinessGroupFilterInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AggregateBusinessGroupFilterInfoApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注グループ一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [orderPackage] 発注単位
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessGroupFilterInfoGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, orderPackage?: string, aggregateBusinessResponsibleUserId?: string, keyWord?: string, options?: any): AxiosPromise<AggregateBusinessGroupFilterInfoResponse> {
            return localVarFp.aggregateBusinessGroupFilterInfoGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, orderPackage, aggregateBusinessResponsibleUserId, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AggregateBusinessGroupFilterInfoApi - object-oriented interface
 * @export
 * @class AggregateBusinessGroupFilterInfoApi
 * @extends {BaseAPI}
 */
export class AggregateBusinessGroupFilterInfoApi extends BaseAPI {
    /**
     * 
     * @summary 発注グループ一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [orderPackage] 発注単位
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessGroupFilterInfoApi
     */
    public aggregateBusinessGroupFilterInfoGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, orderPackage?: string, aggregateBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return AggregateBusinessGroupFilterInfoApiFp(this.configuration).aggregateBusinessGroupFilterInfoGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, orderPackage, aggregateBusinessResponsibleUserId, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AggregateBusinessIdApi - axios parameter creator
 * @export
 */
export const AggregateBusinessIdApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 5つのキー情報から集計テーブルのIDを取得する
         * @param {string} supplierName 仕入先名
         * @param {string} businessNumber 商品コード
         * @param {string} businessName 商品名
         * @param {number} _package 容量
         * @param {string} warehouse 倉庫
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessIdGet: async (supplierName: string, businessNumber: string, businessName: string, _package: number, warehouse: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supplierName' is not null or undefined
            assertParamExists('aggregateBusinessIdGet', 'supplierName', supplierName)
            // verify required parameter 'businessNumber' is not null or undefined
            assertParamExists('aggregateBusinessIdGet', 'businessNumber', businessNumber)
            // verify required parameter 'businessName' is not null or undefined
            assertParamExists('aggregateBusinessIdGet', 'businessName', businessName)
            // verify required parameter '_package' is not null or undefined
            assertParamExists('aggregateBusinessIdGet', '_package', _package)
            // verify required parameter 'warehouse' is not null or undefined
            assertParamExists('aggregateBusinessIdGet', 'warehouse', warehouse)
            const localVarPath = `/aggregate-business-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AggregateBusinessIdApi - functional programming interface
 * @export
 */
export const AggregateBusinessIdApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AggregateBusinessIdApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 5つのキー情報から集計テーブルのIDを取得する
         * @param {string} supplierName 仕入先名
         * @param {string} businessNumber 商品コード
         * @param {string} businessName 商品名
         * @param {number} _package 容量
         * @param {string} warehouse 倉庫
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessIdGet(supplierName: string, businessNumber: string, businessName: string, _package: number, warehouse: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregateBusinessIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessIdGet(supplierName, businessNumber, businessName, _package, warehouse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessIdApi.aggregateBusinessIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AggregateBusinessIdApi - factory interface
 * @export
 */
export const AggregateBusinessIdApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AggregateBusinessIdApiFp(configuration)
    return {
        /**
         * 
         * @summary 5つのキー情報から集計テーブルのIDを取得する
         * @param {string} supplierName 仕入先名
         * @param {string} businessNumber 商品コード
         * @param {string} businessName 商品名
         * @param {number} _package 容量
         * @param {string} warehouse 倉庫
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessIdGet(supplierName: string, businessNumber: string, businessName: string, _package: number, warehouse: string, options?: any): AxiosPromise<AggregateBusinessIdResponse> {
            return localVarFp.aggregateBusinessIdGet(supplierName, businessNumber, businessName, _package, warehouse, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AggregateBusinessIdApi - object-oriented interface
 * @export
 * @class AggregateBusinessIdApi
 * @extends {BaseAPI}
 */
export class AggregateBusinessIdApi extends BaseAPI {
    /**
     * 
     * @summary 5つのキー情報から集計テーブルのIDを取得する
     * @param {string} supplierName 仕入先名
     * @param {string} businessNumber 商品コード
     * @param {string} businessName 商品名
     * @param {number} _package 容量
     * @param {string} warehouse 倉庫
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessIdApi
     */
    public aggregateBusinessIdGet(supplierName: string, businessNumber: string, businessName: string, _package: number, warehouse: string, options?: RawAxiosRequestConfig) {
        return AggregateBusinessIdApiFp(this.configuration).aggregateBusinessIdGet(supplierName, businessNumber, businessName, _package, warehouse, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AggregateBusinessMemoApi - axios parameter creator
 * @export
 */
export const AggregateBusinessMemoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計テーブルにメモを追加する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessMemoAggregateBusinessIdDelete: async (aggregateBusinessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('aggregateBusinessMemoAggregateBusinessIdDelete', 'aggregateBusinessId', aggregateBusinessId)
            const localVarPath = `/aggregate-business-memo/{aggregateBusinessId}`
                .replace(`{${"aggregateBusinessId"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 集計テーブルのメモを更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {AggregateBusinessMemoAggregateBusinessIdPutRequest} aggregateBusinessMemoAggregateBusinessIdPutRequest 登録するメモ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessMemoAggregateBusinessIdPut: async (aggregateBusinessId: string, aggregateBusinessMemoAggregateBusinessIdPutRequest: AggregateBusinessMemoAggregateBusinessIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('aggregateBusinessMemoAggregateBusinessIdPut', 'aggregateBusinessId', aggregateBusinessId)
            // verify required parameter 'aggregateBusinessMemoAggregateBusinessIdPutRequest' is not null or undefined
            assertParamExists('aggregateBusinessMemoAggregateBusinessIdPut', 'aggregateBusinessMemoAggregateBusinessIdPutRequest', aggregateBusinessMemoAggregateBusinessIdPutRequest)
            const localVarPath = `/aggregate-business-memo/{aggregateBusinessId}`
                .replace(`{${"aggregateBusinessId"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggregateBusinessMemoAggregateBusinessIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AggregateBusinessMemoApi - functional programming interface
 * @export
 */
export const AggregateBusinessMemoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AggregateBusinessMemoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計テーブルにメモを追加する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessMemoAggregateBusinessIdDelete(aggregateBusinessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessMemoAggregateBusinessIdDelete(aggregateBusinessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessMemoApi.aggregateBusinessMemoAggregateBusinessIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 集計テーブルのメモを更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {AggregateBusinessMemoAggregateBusinessIdPutRequest} aggregateBusinessMemoAggregateBusinessIdPutRequest 登録するメモ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessMemoAggregateBusinessIdPut(aggregateBusinessId: string, aggregateBusinessMemoAggregateBusinessIdPutRequest: AggregateBusinessMemoAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessMemoAggregateBusinessIdPut(aggregateBusinessId, aggregateBusinessMemoAggregateBusinessIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessMemoApi.aggregateBusinessMemoAggregateBusinessIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AggregateBusinessMemoApi - factory interface
 * @export
 */
export const AggregateBusinessMemoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AggregateBusinessMemoApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計テーブルにメモを追加する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessMemoAggregateBusinessIdDelete(aggregateBusinessId: string, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.aggregateBusinessMemoAggregateBusinessIdDelete(aggregateBusinessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 集計テーブルのメモを更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {AggregateBusinessMemoAggregateBusinessIdPutRequest} aggregateBusinessMemoAggregateBusinessIdPutRequest 登録するメモ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessMemoAggregateBusinessIdPut(aggregateBusinessId: string, aggregateBusinessMemoAggregateBusinessIdPutRequest: AggregateBusinessMemoAggregateBusinessIdPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.aggregateBusinessMemoAggregateBusinessIdPut(aggregateBusinessId, aggregateBusinessMemoAggregateBusinessIdPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AggregateBusinessMemoApi - object-oriented interface
 * @export
 * @class AggregateBusinessMemoApi
 * @extends {BaseAPI}
 */
export class AggregateBusinessMemoApi extends BaseAPI {
    /**
     * 
     * @summary 集計テーブルにメモを追加する
     * @param {string} aggregateBusinessId 集計テーブルのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessMemoApi
     */
    public aggregateBusinessMemoAggregateBusinessIdDelete(aggregateBusinessId: string, options?: RawAxiosRequestConfig) {
        return AggregateBusinessMemoApiFp(this.configuration).aggregateBusinessMemoAggregateBusinessIdDelete(aggregateBusinessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 集計テーブルのメモを更新する
     * @param {string} aggregateBusinessId 集計テーブルのID
     * @param {AggregateBusinessMemoAggregateBusinessIdPutRequest} aggregateBusinessMemoAggregateBusinessIdPutRequest 登録するメモ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessMemoApi
     */
    public aggregateBusinessMemoAggregateBusinessIdPut(aggregateBusinessId: string, aggregateBusinessMemoAggregateBusinessIdPutRequest: AggregateBusinessMemoAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig) {
        return AggregateBusinessMemoApiFp(this.configuration).aggregateBusinessMemoAggregateBusinessIdPut(aggregateBusinessId, aggregateBusinessMemoAggregateBusinessIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AggregateBusinessResponsibleUserApi - axios parameter creator
 * @export
 */
export const AggregateBusinessResponsibleUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計取引担当者一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessResponsibleUserGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/aggregate-business-responsible-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AggregateBusinessResponsibleUserApi - functional programming interface
 * @export
 */
export const AggregateBusinessResponsibleUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AggregateBusinessResponsibleUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計取引担当者一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessResponsibleUserGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregateBusinessResponsibleUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessResponsibleUserGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessResponsibleUserApi.aggregateBusinessResponsibleUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AggregateBusinessResponsibleUserApi - factory interface
 * @export
 */
export const AggregateBusinessResponsibleUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AggregateBusinessResponsibleUserApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計取引担当者一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessResponsibleUserGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<AggregateBusinessResponsibleUserResponse> {
            return localVarFp.aggregateBusinessResponsibleUserGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AggregateBusinessResponsibleUserApi - object-oriented interface
 * @export
 * @class AggregateBusinessResponsibleUserApi
 * @extends {BaseAPI}
 */
export class AggregateBusinessResponsibleUserApi extends BaseAPI {
    /**
     * 
     * @summary 集計取引担当者一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessResponsibleUserApi
     */
    public aggregateBusinessResponsibleUserGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return AggregateBusinessResponsibleUserApiFp(this.configuration).aggregateBusinessResponsibleUserGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AggregateFreeColumnApi - axios parameter creator
 * @export
 */
export const AggregateFreeColumnApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計の自由カラムの値を取得する
         * @param {string} [keyword] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateFreeColumnGet: async (keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/aggregate-free-column`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AggregateFreeColumnApi - functional programming interface
 * @export
 */
export const AggregateFreeColumnApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AggregateFreeColumnApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計の自由カラムの値を取得する
         * @param {string} [keyword] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateFreeColumnGet(keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeColumnValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateFreeColumnGet(keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateFreeColumnApi.aggregateFreeColumnGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AggregateFreeColumnApi - factory interface
 * @export
 */
export const AggregateFreeColumnApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AggregateFreeColumnApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計の自由カラムの値を取得する
         * @param {string} [keyword] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateFreeColumnGet(keyword?: string, options?: any): AxiosPromise<GetFreeColumnValuesResponse> {
            return localVarFp.aggregateFreeColumnGet(keyword, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AggregateFreeColumnApi - object-oriented interface
 * @export
 * @class AggregateFreeColumnApi
 * @extends {BaseAPI}
 */
export class AggregateFreeColumnApi extends BaseAPI {
    /**
     * 
     * @summary 集計の自由カラムの値を取得する
     * @param {string} [keyword] キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateFreeColumnApi
     */
    public aggregateFreeColumnGet(keyword?: string, options?: RawAxiosRequestConfig) {
        return AggregateFreeColumnApiFp(this.configuration).aggregateFreeColumnGet(keyword, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AlertVisibilityApi - axios parameter creator
 * @export
 */
export const AlertVisibilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計のアラートの表示を変更する
         * @param {AggregateBusinessAlertVisibilityPutRequest} aggregateBusinessAlertVisibilityPutRequest 変更する集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessAlertVisibilityPut: async (aggregateBusinessAlertVisibilityPutRequest: AggregateBusinessAlertVisibilityPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessAlertVisibilityPutRequest' is not null or undefined
            assertParamExists('aggregateBusinessAlertVisibilityPut', 'aggregateBusinessAlertVisibilityPutRequest', aggregateBusinessAlertVisibilityPutRequest)
            const localVarPath = `/aggregate-business/alert/visibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggregateBusinessAlertVisibilityPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlertVisibilityApi - functional programming interface
 * @export
 */
export const AlertVisibilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlertVisibilityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計のアラートの表示を変更する
         * @param {AggregateBusinessAlertVisibilityPutRequest} aggregateBusinessAlertVisibilityPutRequest 変更する集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessAlertVisibilityPut(aggregateBusinessAlertVisibilityPutRequest: AggregateBusinessAlertVisibilityPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessAlertVisibilityPut(aggregateBusinessAlertVisibilityPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertVisibilityApi.aggregateBusinessAlertVisibilityPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlertVisibilityApi - factory interface
 * @export
 */
export const AlertVisibilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlertVisibilityApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計のアラートの表示を変更する
         * @param {AggregateBusinessAlertVisibilityPutRequest} aggregateBusinessAlertVisibilityPutRequest 変更する集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessAlertVisibilityPut(aggregateBusinessAlertVisibilityPutRequest: AggregateBusinessAlertVisibilityPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.aggregateBusinessAlertVisibilityPut(aggregateBusinessAlertVisibilityPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlertVisibilityApi - object-oriented interface
 * @export
 * @class AlertVisibilityApi
 * @extends {BaseAPI}
 */
export class AlertVisibilityApi extends BaseAPI {
    /**
     * 
     * @summary 集計のアラートの表示を変更する
     * @param {AggregateBusinessAlertVisibilityPutRequest} aggregateBusinessAlertVisibilityPutRequest 変更する集計情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertVisibilityApi
     */
    public aggregateBusinessAlertVisibilityPut(aggregateBusinessAlertVisibilityPutRequest: AggregateBusinessAlertVisibilityPutRequest, options?: RawAxiosRequestConfig) {
        return AlertVisibilityApiFp(this.configuration).aggregateBusinessAlertVisibilityPut(aggregateBusinessAlertVisibilityPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BusinessNameApi - axios parameter creator
 * @export
 */
export const BusinessNameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 商品名一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessNameGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/business-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessNameApi - functional programming interface
 * @export
 */
export const BusinessNameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessNameApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 商品名一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async businessNameGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.businessNameGet(supplierNumber, supplierName, businessNumber, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessNameApi.businessNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessNameApi - factory interface
 * @export
 */
export const BusinessNameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessNameApiFp(configuration)
    return {
        /**
         * 
         * @summary 商品名一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessNameGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<BusinessNameResponse> {
            return localVarFp.businessNameGet(supplierNumber, supplierName, businessNumber, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessNameApi - object-oriented interface
 * @export
 * @class BusinessNameApi
 * @extends {BaseAPI}
 */
export class BusinessNameApi extends BaseAPI {
    /**
     * 
     * @summary 商品名一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessNameApi
     */
    public businessNameGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return BusinessNameApiFp(this.configuration).businessNameGet(supplierNumber, supplierName, businessNumber, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BusinessNameFromMasterApi - axios parameter creator
 * @export
 */
export const BusinessNameFromMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 商品名一覧を取得する（マスタから取得する）
         * @param {string} [businessName] 商品名
         * @param {string} [businessNumber] 商品コード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessNameFromMasterGet: async (businessName?: string, businessNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/business-name-from-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessNameFromMasterApi - functional programming interface
 * @export
 */
export const BusinessNameFromMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessNameFromMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 商品名一覧を取得する（マスタから取得する）
         * @param {string} [businessName] 商品名
         * @param {string} [businessNumber] 商品コード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async businessNameFromMasterGet(businessName?: string, businessNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessNameFromMasterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.businessNameFromMasterGet(businessName, businessNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessNameFromMasterApi.businessNameFromMasterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessNameFromMasterApi - factory interface
 * @export
 */
export const BusinessNameFromMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessNameFromMasterApiFp(configuration)
    return {
        /**
         * 
         * @summary 商品名一覧を取得する（マスタから取得する）
         * @param {string} [businessName] 商品名
         * @param {string} [businessNumber] 商品コード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessNameFromMasterGet(businessName?: string, businessNumber?: string, options?: any): AxiosPromise<BusinessNameFromMasterResponse> {
            return localVarFp.businessNameFromMasterGet(businessName, businessNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessNameFromMasterApi - object-oriented interface
 * @export
 * @class BusinessNameFromMasterApi
 * @extends {BaseAPI}
 */
export class BusinessNameFromMasterApi extends BaseAPI {
    /**
     * 
     * @summary 商品名一覧を取得する（マスタから取得する）
     * @param {string} [businessName] 商品名
     * @param {string} [businessNumber] 商品コード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessNameFromMasterApi
     */
    public businessNameFromMasterGet(businessName?: string, businessNumber?: string, options?: RawAxiosRequestConfig) {
        return BusinessNameFromMasterApiFp(this.configuration).businessNameFromMasterGet(businessName, businessNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BusinessNumberApi - axios parameter creator
 * @export
 */
export const BusinessNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 商品コード一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessNumberGet: async (supplierNumber?: string, supplierName?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/business-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessNumberApi - functional programming interface
 * @export
 */
export const BusinessNumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessNumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 商品コード一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async businessNumberGet(supplierNumber?: string, supplierName?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.businessNumberGet(supplierNumber, supplierName, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessNumberApi.businessNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessNumberApi - factory interface
 * @export
 */
export const BusinessNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessNumberApiFp(configuration)
    return {
        /**
         * 
         * @summary 商品コード一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessNumberGet(supplierNumber?: string, supplierName?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<BusinessNumberResponse> {
            return localVarFp.businessNumberGet(supplierNumber, supplierName, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessNumberApi - object-oriented interface
 * @export
 * @class BusinessNumberApi
 * @extends {BaseAPI}
 */
export class BusinessNumberApi extends BaseAPI {
    /**
     * 
     * @summary 商品コード一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessNumberApi
     */
    public businessNumberGet(supplierNumber?: string, supplierName?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return BusinessNumberApiFp(this.configuration).businessNumberGet(supplierNumber, supplierName, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CheckDuplicateAggregateBusinessApi - axios parameter creator
 * @export
 */
export const CheckDuplicateAggregateBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 指定したパラメータに対するAggregateBusiness、BaseBusinessが存在するかどうかを取得する
         * @param {ExistsAggregateBusinessAndBaseBusinessParameters} [aggregateBusinessBaseBusinessAPI] 
         * @param {number} [getBusinessCount] 集計と関連取引がどちらも存在する場合に取得する取引情報の数
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsAggregateBusinessAndBaseBusinessGet: async (aggregateBusinessBaseBusinessAPI?: ExistsAggregateBusinessAndBaseBusinessParameters, getBusinessCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exists-aggregate-business-and-base-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aggregateBusinessBaseBusinessAPI !== undefined) {
                for (const [key, value] of Object.entries(aggregateBusinessBaseBusinessAPI)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (getBusinessCount !== undefined) {
                localVarQueryParameter['getBusinessCount'] = getBusinessCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CheckDuplicateAggregateBusinessApi - functional programming interface
 * @export
 */
export const CheckDuplicateAggregateBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CheckDuplicateAggregateBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 指定したパラメータに対するAggregateBusiness、BaseBusinessが存在するかどうかを取得する
         * @param {ExistsAggregateBusinessAndBaseBusinessParameters} [aggregateBusinessBaseBusinessAPI] 
         * @param {number} [getBusinessCount] 集計と関連取引がどちらも存在する場合に取得する取引情報の数
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsAggregateBusinessAndBaseBusinessGet(aggregateBusinessBaseBusinessAPI?: ExistsAggregateBusinessAndBaseBusinessParameters, getBusinessCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExistsAggregateBusinessAndBaseBusiness>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsAggregateBusinessAndBaseBusinessGet(aggregateBusinessBaseBusinessAPI, getBusinessCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckDuplicateAggregateBusinessApi.existsAggregateBusinessAndBaseBusinessGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CheckDuplicateAggregateBusinessApi - factory interface
 * @export
 */
export const CheckDuplicateAggregateBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CheckDuplicateAggregateBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary 指定したパラメータに対するAggregateBusiness、BaseBusinessが存在するかどうかを取得する
         * @param {ExistsAggregateBusinessAndBaseBusinessParameters} [aggregateBusinessBaseBusinessAPI] 
         * @param {number} [getBusinessCount] 集計と関連取引がどちらも存在する場合に取得する取引情報の数
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsAggregateBusinessAndBaseBusinessGet(aggregateBusinessBaseBusinessAPI?: ExistsAggregateBusinessAndBaseBusinessParameters, getBusinessCount?: number, options?: any): AxiosPromise<ExistsAggregateBusinessAndBaseBusiness> {
            return localVarFp.existsAggregateBusinessAndBaseBusinessGet(aggregateBusinessBaseBusinessAPI, getBusinessCount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CheckDuplicateAggregateBusinessApi - object-oriented interface
 * @export
 * @class CheckDuplicateAggregateBusinessApi
 * @extends {BaseAPI}
 */
export class CheckDuplicateAggregateBusinessApi extends BaseAPI {
    /**
     * 
     * @summary 指定したパラメータに対するAggregateBusiness、BaseBusinessが存在するかどうかを取得する
     * @param {ExistsAggregateBusinessAndBaseBusinessParameters} [aggregateBusinessBaseBusinessAPI] 
     * @param {number} [getBusinessCount] 集計と関連取引がどちらも存在する場合に取得する取引情報の数
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckDuplicateAggregateBusinessApi
     */
    public existsAggregateBusinessAndBaseBusinessGet(aggregateBusinessBaseBusinessAPI?: ExistsAggregateBusinessAndBaseBusinessParameters, getBusinessCount?: number, options?: RawAxiosRequestConfig) {
        return CheckDuplicateAggregateBusinessApiFp(this.configuration).existsAggregateBusinessAndBaseBusinessGet(aggregateBusinessBaseBusinessAPI, getBusinessCount, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExistsAggregateBusinessApi - axios parameter creator
 * @export
 */
export const ExistsAggregateBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 指定したパラメータに対するAggregateBusinessが存在するかどうかを取得する
         * @param {ExistsAggregateBusinessParameters} [aggregateBusinessAPI] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsAggregateBusinessGet: async (aggregateBusinessAPI?: ExistsAggregateBusinessParameters, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exists-aggregate-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aggregateBusinessAPI !== undefined) {
                for (const [key, value] of Object.entries(aggregateBusinessAPI)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExistsAggregateBusinessApi - functional programming interface
 * @export
 */
export const ExistsAggregateBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExistsAggregateBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 指定したパラメータに対するAggregateBusinessが存在するかどうかを取得する
         * @param {ExistsAggregateBusinessParameters} [aggregateBusinessAPI] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsAggregateBusinessGet(aggregateBusinessAPI?: ExistsAggregateBusinessParameters, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExistsAggregateBusinessSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsAggregateBusinessGet(aggregateBusinessAPI, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExistsAggregateBusinessApi.existsAggregateBusinessGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExistsAggregateBusinessApi - factory interface
 * @export
 */
export const ExistsAggregateBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExistsAggregateBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary 指定したパラメータに対するAggregateBusinessが存在するかどうかを取得する
         * @param {ExistsAggregateBusinessParameters} [aggregateBusinessAPI] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsAggregateBusinessGet(aggregateBusinessAPI?: ExistsAggregateBusinessParameters, options?: any): AxiosPromise<ExistsAggregateBusinessSuccess> {
            return localVarFp.existsAggregateBusinessGet(aggregateBusinessAPI, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExistsAggregateBusinessApi - object-oriented interface
 * @export
 * @class ExistsAggregateBusinessApi
 * @extends {BaseAPI}
 */
export class ExistsAggregateBusinessApi extends BaseAPI {
    /**
     * 
     * @summary 指定したパラメータに対するAggregateBusinessが存在するかどうかを取得する
     * @param {ExistsAggregateBusinessParameters} [aggregateBusinessAPI] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExistsAggregateBusinessApi
     */
    public existsAggregateBusinessGet(aggregateBusinessAPI?: ExistsAggregateBusinessParameters, options?: RawAxiosRequestConfig) {
        return ExistsAggregateBusinessApiFp(this.configuration).existsAggregateBusinessGet(aggregateBusinessAPI, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GetForecastAccuracyHistoryApi - axios parameter creator
 * @export
 */
export const GetForecastAccuracyHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 客先内示/販売実績の集計情報の過去実績一覧を取得する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {number} startYear 開始年
         * @param {number} startMonth 開始月
         * @param {number} [period] 期間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet: async (aggregateBusinessId: string, startYear: number, startMonth: number, period?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet', 'aggregateBusinessId', aggregateBusinessId)
            // verify required parameter 'startYear' is not null or undefined
            assertParamExists('forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet', 'startYear', startYear)
            // verify required parameter 'startMonth' is not null or undefined
            assertParamExists('forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet', 'startMonth', startMonth)
            const localVarPath = `/forecast-accuracy-history-from-summary-data/{aggregate_business_id}`
                .replace(`{${"aggregate_business_id"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startYear !== undefined) {
                localVarQueryParameter['startYear'] = startYear;
            }

            if (startMonth !== undefined) {
                localVarQueryParameter['startMonth'] = startMonth;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetForecastAccuracyHistoryApi - functional programming interface
 * @export
 */
export const GetForecastAccuracyHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetForecastAccuracyHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 客先内示/販売実績の集計情報の過去実績一覧を取得する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {number} startYear 開始年
         * @param {number} startMonth 開始月
         * @param {number} [period] 期間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet(aggregateBusinessId: string, startYear: number, startMonth: number, period?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForecastAccuracyHistoryFromSummaryDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet(aggregateBusinessId, startYear, startMonth, period, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GetForecastAccuracyHistoryApi.forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GetForecastAccuracyHistoryApi - factory interface
 * @export
 */
export const GetForecastAccuracyHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetForecastAccuracyHistoryApiFp(configuration)
    return {
        /**
         * 
         * @summary 客先内示/販売実績の集計情報の過去実績一覧を取得する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {number} startYear 開始年
         * @param {number} startMonth 開始月
         * @param {number} [period] 期間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet(aggregateBusinessId: string, startYear: number, startMonth: number, period?: number, options?: any): AxiosPromise<ForecastAccuracyHistoryFromSummaryDataResponse> {
            return localVarFp.forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet(aggregateBusinessId, startYear, startMonth, period, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetForecastAccuracyHistoryApi - object-oriented interface
 * @export
 * @class GetForecastAccuracyHistoryApi
 * @extends {BaseAPI}
 */
export class GetForecastAccuracyHistoryApi extends BaseAPI {
    /**
     * 
     * @summary 客先内示/販売実績の集計情報の過去実績一覧を取得する
     * @param {string} aggregateBusinessId 集計テーブルのID
     * @param {number} startYear 開始年
     * @param {number} startMonth 開始月
     * @param {number} [period] 期間
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetForecastAccuracyHistoryApi
     */
    public forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet(aggregateBusinessId: string, startYear: number, startMonth: number, period?: number, options?: RawAxiosRequestConfig) {
        return GetForecastAccuracyHistoryApiFp(this.configuration).forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet(aggregateBusinessId, startYear, startMonth, period, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LastCheckedApi - axios parameter creator
 * @export
 */
export const LastCheckedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計のチェック情報を更新する
         * @param {string} aggregateBusinessId 集計ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lastCheckedAggregateBusinessIdPut: async (aggregateBusinessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('lastCheckedAggregateBusinessIdPut', 'aggregateBusinessId', aggregateBusinessId)
            const localVarPath = `/last-checked/{aggregate_business_id}`
                .replace(`{${"aggregate_business_id"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LastCheckedApi - functional programming interface
 * @export
 */
export const LastCheckedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LastCheckedApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計のチェック情報を更新する
         * @param {string} aggregateBusinessId 集計ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lastCheckedAggregateBusinessIdPut(aggregateBusinessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutLastCheckedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lastCheckedAggregateBusinessIdPut(aggregateBusinessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LastCheckedApi.lastCheckedAggregateBusinessIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LastCheckedApi - factory interface
 * @export
 */
export const LastCheckedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LastCheckedApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計のチェック情報を更新する
         * @param {string} aggregateBusinessId 集計ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lastCheckedAggregateBusinessIdPut(aggregateBusinessId: string, options?: any): AxiosPromise<PutLastCheckedResponse> {
            return localVarFp.lastCheckedAggregateBusinessIdPut(aggregateBusinessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LastCheckedApi - object-oriented interface
 * @export
 * @class LastCheckedApi
 * @extends {BaseAPI}
 */
export class LastCheckedApi extends BaseAPI {
    /**
     * 
     * @summary 集計のチェック情報を更新する
     * @param {string} aggregateBusinessId 集計ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LastCheckedApi
     */
    public lastCheckedAggregateBusinessIdPut(aggregateBusinessId: string, options?: RawAxiosRequestConfig) {
        return LastCheckedApiFp(this.configuration).lastCheckedAggregateBusinessIdPut(aggregateBusinessId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LeadTimeApi - axios parameter creator
 * @export
 */
export const LeadTimeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary リードタイムを更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {LeadTimeAggregateBusinessIdPutRequest} leadTimeAggregateBusinessIdPutRequest リードタイムを更新する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadTimeAggregateBusinessIdPut: async (aggregateBusinessId: string, leadTimeAggregateBusinessIdPutRequest: LeadTimeAggregateBusinessIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('leadTimeAggregateBusinessIdPut', 'aggregateBusinessId', aggregateBusinessId)
            // verify required parameter 'leadTimeAggregateBusinessIdPutRequest' is not null or undefined
            assertParamExists('leadTimeAggregateBusinessIdPut', 'leadTimeAggregateBusinessIdPutRequest', leadTimeAggregateBusinessIdPutRequest)
            const localVarPath = `/lead-time/{aggregate_business_id}`
                .replace(`{${"aggregate_business_id"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadTimeAggregateBusinessIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary リードタイム一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadTimeGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lead-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadTimeApi - functional programming interface
 * @export
 */
export const LeadTimeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeadTimeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary リードタイムを更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {LeadTimeAggregateBusinessIdPutRequest} leadTimeAggregateBusinessIdPutRequest リードタイムを更新する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadTimeAggregateBusinessIdPut(aggregateBusinessId: string, leadTimeAggregateBusinessIdPutRequest: LeadTimeAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadTimeAggregateBusinessIdPut(aggregateBusinessId, leadTimeAggregateBusinessIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadTimeApi.leadTimeAggregateBusinessIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary リードタイム一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leadTimeGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadTimeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leadTimeGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadTimeApi.leadTimeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeadTimeApi - factory interface
 * @export
 */
export const LeadTimeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeadTimeApiFp(configuration)
    return {
        /**
         * 
         * @summary リードタイムを更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {LeadTimeAggregateBusinessIdPutRequest} leadTimeAggregateBusinessIdPutRequest リードタイムを更新する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadTimeAggregateBusinessIdPut(aggregateBusinessId: string, leadTimeAggregateBusinessIdPutRequest: LeadTimeAggregateBusinessIdPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.leadTimeAggregateBusinessIdPut(aggregateBusinessId, leadTimeAggregateBusinessIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary リードタイム一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leadTimeGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<LeadTimeResponse> {
            return localVarFp.leadTimeGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeadTimeApi - object-oriented interface
 * @export
 * @class LeadTimeApi
 * @extends {BaseAPI}
 */
export class LeadTimeApi extends BaseAPI {
    /**
     * 
     * @summary リードタイムを更新する
     * @param {string} aggregateBusinessId 集計テーブルのID
     * @param {LeadTimeAggregateBusinessIdPutRequest} leadTimeAggregateBusinessIdPutRequest リードタイムを更新する情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadTimeApi
     */
    public leadTimeAggregateBusinessIdPut(aggregateBusinessId: string, leadTimeAggregateBusinessIdPutRequest: LeadTimeAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig) {
        return LeadTimeApiFp(this.configuration).leadTimeAggregateBusinessIdPut(aggregateBusinessId, leadTimeAggregateBusinessIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary リードタイム一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadTimeApi
     */
    public leadTimeGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return LeadTimeApiFp(this.configuration).leadTimeGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ManufacturerApi - axios parameter creator
 * @export
 */
export const ManufacturerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 製造社一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manufacturerGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/manufacturer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManufacturerApi - functional programming interface
 * @export
 */
export const ManufacturerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManufacturerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 製造社一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manufacturerGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManufacturerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manufacturerGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManufacturerApi.manufacturerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManufacturerApi - factory interface
 * @export
 */
export const ManufacturerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManufacturerApiFp(configuration)
    return {
        /**
         * 
         * @summary 製造社一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manufacturerGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<ManufacturerResponse> {
            return localVarFp.manufacturerGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ManufacturerApi - object-oriented interface
 * @export
 * @class ManufacturerApi
 * @extends {BaseAPI}
 */
export class ManufacturerApi extends BaseAPI {
    /**
     * 
     * @summary 製造社一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManufacturerApi
     */
    public manufacturerGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return ManufacturerApiFp(this.configuration).manufacturerGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MoqApi - axios parameter creator
 * @export
 */
export const MoqApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary MOQを更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {MoqAggregateBusinessIdPutRequest} moqAggregateBusinessIdPutRequest 更新するMOQ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moqAggregateBusinessIdPut: async (aggregateBusinessId: string, moqAggregateBusinessIdPutRequest: MoqAggregateBusinessIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('moqAggregateBusinessIdPut', 'aggregateBusinessId', aggregateBusinessId)
            // verify required parameter 'moqAggregateBusinessIdPutRequest' is not null or undefined
            assertParamExists('moqAggregateBusinessIdPut', 'moqAggregateBusinessIdPutRequest', moqAggregateBusinessIdPutRequest)
            const localVarPath = `/moq/{aggregate_business_id}`
                .replace(`{${"aggregate_business_id"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moqAggregateBusinessIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary MOQ一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moqGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/moq`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MoqApi - functional programming interface
 * @export
 */
export const MoqApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MoqApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary MOQを更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {MoqAggregateBusinessIdPutRequest} moqAggregateBusinessIdPutRequest 更新するMOQ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moqAggregateBusinessIdPut(aggregateBusinessId: string, moqAggregateBusinessIdPutRequest: MoqAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moqAggregateBusinessIdPut(aggregateBusinessId, moqAggregateBusinessIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoqApi.moqAggregateBusinessIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary MOQ一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moqGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoqResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moqGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoqApi.moqGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MoqApi - factory interface
 * @export
 */
export const MoqApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MoqApiFp(configuration)
    return {
        /**
         * 
         * @summary MOQを更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {MoqAggregateBusinessIdPutRequest} moqAggregateBusinessIdPutRequest 更新するMOQ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moqAggregateBusinessIdPut(aggregateBusinessId: string, moqAggregateBusinessIdPutRequest: MoqAggregateBusinessIdPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.moqAggregateBusinessIdPut(aggregateBusinessId, moqAggregateBusinessIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary MOQ一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moqGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<MoqResponse> {
            return localVarFp.moqGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MoqApi - object-oriented interface
 * @export
 * @class MoqApi
 * @extends {BaseAPI}
 */
export class MoqApi extends BaseAPI {
    /**
     * 
     * @summary MOQを更新する
     * @param {string} aggregateBusinessId 集計テーブルのID
     * @param {MoqAggregateBusinessIdPutRequest} moqAggregateBusinessIdPutRequest 更新するMOQ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoqApi
     */
    public moqAggregateBusinessIdPut(aggregateBusinessId: string, moqAggregateBusinessIdPutRequest: MoqAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig) {
        return MoqApiFp(this.configuration).moqAggregateBusinessIdPut(aggregateBusinessId, moqAggregateBusinessIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary MOQ一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoqApi
     */
    public moqGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return MoqApiFp(this.configuration).moqGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderPackageApi - axios parameter creator
 * @export
 */
export const OrderPackageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary orderPackage(発注単位)を更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {OrderPackageAggregateBusinessIdPutRequest} orderPackageAggregateBusinessIdPutRequest 更新する発注単位の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPackageAggregateBusinessIdPut: async (aggregateBusinessId: string, orderPackageAggregateBusinessIdPutRequest: OrderPackageAggregateBusinessIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('orderPackageAggregateBusinessIdPut', 'aggregateBusinessId', aggregateBusinessId)
            // verify required parameter 'orderPackageAggregateBusinessIdPutRequest' is not null or undefined
            assertParamExists('orderPackageAggregateBusinessIdPut', 'orderPackageAggregateBusinessIdPutRequest', orderPackageAggregateBusinessIdPutRequest)
            const localVarPath = `/order-package/{aggregate_business_id}`
                .replace(`{${"aggregate_business_id"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderPackageAggregateBusinessIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注単位一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPackageGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-package`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderPackageApi - functional programming interface
 * @export
 */
export const OrderPackageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderPackageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary orderPackage(発注単位)を更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {OrderPackageAggregateBusinessIdPutRequest} orderPackageAggregateBusinessIdPutRequest 更新する発注単位の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderPackageAggregateBusinessIdPut(aggregateBusinessId: string, orderPackageAggregateBusinessIdPutRequest: OrderPackageAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderPackageAggregateBusinessIdPut(aggregateBusinessId, orderPackageAggregateBusinessIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPackageApi.orderPackageAggregateBusinessIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注単位一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderPackageGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderPackageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderPackageGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderPackageApi.orderPackageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderPackageApi - factory interface
 * @export
 */
export const OrderPackageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderPackageApiFp(configuration)
    return {
        /**
         * 
         * @summary orderPackage(発注単位)を更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {OrderPackageAggregateBusinessIdPutRequest} orderPackageAggregateBusinessIdPutRequest 更新する発注単位の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPackageAggregateBusinessIdPut(aggregateBusinessId: string, orderPackageAggregateBusinessIdPutRequest: OrderPackageAggregateBusinessIdPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.orderPackageAggregateBusinessIdPut(aggregateBusinessId, orderPackageAggregateBusinessIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注単位一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPackageGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, keyWord?: string, options?: any): AxiosPromise<OrderPackageResponse> {
            return localVarFp.orderPackageGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderPackageApi - object-oriented interface
 * @export
 * @class OrderPackageApi
 * @extends {BaseAPI}
 */
export class OrderPackageApi extends BaseAPI {
    /**
     * 
     * @summary orderPackage(発注単位)を更新する
     * @param {string} aggregateBusinessId 集計テーブルのID
     * @param {OrderPackageAggregateBusinessIdPutRequest} orderPackageAggregateBusinessIdPutRequest 更新する発注単位の情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderPackageApi
     */
    public orderPackageAggregateBusinessIdPut(aggregateBusinessId: string, orderPackageAggregateBusinessIdPutRequest: OrderPackageAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig) {
        return OrderPackageApiFp(this.configuration).orderPackageAggregateBusinessIdPut(aggregateBusinessId, orderPackageAggregateBusinessIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注単位一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderPackageApi
     */
    public orderPackageGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return OrderPackageApiFp(this.configuration).orderPackageGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PackageApi - axios parameter creator
 * @export
 */
export const PackageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 容量一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packageGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/package`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PackageApi - functional programming interface
 * @export
 */
export const PackageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PackageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 容量一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async packageGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PackageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.packageGet(supplierNumber, supplierName, businessNumber, businessName, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PackageApi.packageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PackageApi - factory interface
 * @export
 */
export const PackageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PackageApiFp(configuration)
    return {
        /**
         * 
         * @summary 容量一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packageGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<PackageResponse> {
            return localVarFp.packageGet(supplierNumber, supplierName, businessNumber, businessName, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PackageApi - object-oriented interface
 * @export
 * @class PackageApi
 * @extends {BaseAPI}
 */
export class PackageApi extends BaseAPI {
    /**
     * 
     * @summary 容量一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageApi
     */
    public packageGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return PackageApiFp(this.configuration).packageGet(supplierNumber, supplierName, businessNumber, businessName, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PurchaseUnitPriceApi - axios parameter creator
 * @export
 */
export const PurchaseUnitPriceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 仕入単価一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseUnitPriceGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/purchase-unit-price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseUnitPriceApi - functional programming interface
 * @export
 */
export const PurchaseUnitPriceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseUnitPriceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 仕入単価一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purchaseUnitPriceGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseUnitPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseUnitPriceGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseUnitPriceApi.purchaseUnitPriceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PurchaseUnitPriceApi - factory interface
 * @export
 */
export const PurchaseUnitPriceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseUnitPriceApiFp(configuration)
    return {
        /**
         * 
         * @summary 仕入単価一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseUnitPriceGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<PurchaseUnitPriceResponse> {
            return localVarFp.purchaseUnitPriceGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseUnitPriceApi - object-oriented interface
 * @export
 * @class PurchaseUnitPriceApi
 * @extends {BaseAPI}
 */
export class PurchaseUnitPriceApi extends BaseAPI {
    /**
     * 
     * @summary 仕入単価一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseUnitPriceApi
     */
    public purchaseUnitPriceGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return PurchaseUnitPriceApiFp(this.configuration).purchaseUnitPriceGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecommendHiddenApi - axios parameter creator
 * @export
 */
export const RecommendHiddenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計の推奨を一時的に非表示にする
         * @param {AggregateBusinessRecommendHiddenPutRequest} aggregateBusinessRecommendHiddenPutRequest 非表示にする集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessRecommendHiddenPut: async (aggregateBusinessRecommendHiddenPutRequest: AggregateBusinessRecommendHiddenPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessRecommendHiddenPutRequest' is not null or undefined
            assertParamExists('aggregateBusinessRecommendHiddenPut', 'aggregateBusinessRecommendHiddenPutRequest', aggregateBusinessRecommendHiddenPutRequest)
            const localVarPath = `/aggregate-business/recommend/hidden`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aggregateBusinessRecommendHiddenPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecommendHiddenApi - functional programming interface
 * @export
 */
export const RecommendHiddenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecommendHiddenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計の推奨を一時的に非表示にする
         * @param {AggregateBusinessRecommendHiddenPutRequest} aggregateBusinessRecommendHiddenPutRequest 非表示にする集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aggregateBusinessRecommendHiddenPut(aggregateBusinessRecommendHiddenPutRequest: AggregateBusinessRecommendHiddenPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aggregateBusinessRecommendHiddenPut(aggregateBusinessRecommendHiddenPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendHiddenApi.aggregateBusinessRecommendHiddenPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecommendHiddenApi - factory interface
 * @export
 */
export const RecommendHiddenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecommendHiddenApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計の推奨を一時的に非表示にする
         * @param {AggregateBusinessRecommendHiddenPutRequest} aggregateBusinessRecommendHiddenPutRequest 非表示にする集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggregateBusinessRecommendHiddenPut(aggregateBusinessRecommendHiddenPutRequest: AggregateBusinessRecommendHiddenPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.aggregateBusinessRecommendHiddenPut(aggregateBusinessRecommendHiddenPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecommendHiddenApi - object-oriented interface
 * @export
 * @class RecommendHiddenApi
 * @extends {BaseAPI}
 */
export class RecommendHiddenApi extends BaseAPI {
    /**
     * 
     * @summary 集計の推奨を一時的に非表示にする
     * @param {AggregateBusinessRecommendHiddenPutRequest} aggregateBusinessRecommendHiddenPutRequest 非表示にする集計情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendHiddenApi
     */
    public aggregateBusinessRecommendHiddenPut(aggregateBusinessRecommendHiddenPutRequest: AggregateBusinessRecommendHiddenPutRequest, options?: RawAxiosRequestConfig) {
        return RecommendHiddenApiFp(this.configuration).aggregateBusinessRecommendHiddenPut(aggregateBusinessRecommendHiddenPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SimulateAggregateBusinessApi - axios parameter creator
 * @export
 */
export const SimulateAggregateBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 在庫シミュレーション用の集計テーブル情報を取得する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateAggregateBusinessAggregateBusinessIdGet: async (aggregateBusinessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('simulateAggregateBusinessAggregateBusinessIdGet', 'aggregateBusinessId', aggregateBusinessId)
            const localVarPath = `/simulate-aggregate-business/{aggregateBusinessId}`
                .replace(`{${"aggregateBusinessId"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimulateAggregateBusinessApi - functional programming interface
 * @export
 */
export const SimulateAggregateBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimulateAggregateBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 在庫シミュレーション用の集計テーブル情報を取得する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulateAggregateBusinessAggregateBusinessIdGet(aggregateBusinessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSimulatedAggregateBusinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simulateAggregateBusinessAggregateBusinessIdGet(aggregateBusinessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulateAggregateBusinessApi.simulateAggregateBusinessAggregateBusinessIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SimulateAggregateBusinessApi - factory interface
 * @export
 */
export const SimulateAggregateBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimulateAggregateBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary 在庫シミュレーション用の集計テーブル情報を取得する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateAggregateBusinessAggregateBusinessIdGet(aggregateBusinessId: string, options?: any): AxiosPromise<GetSimulatedAggregateBusinessResponse> {
            return localVarFp.simulateAggregateBusinessAggregateBusinessIdGet(aggregateBusinessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimulateAggregateBusinessApi - object-oriented interface
 * @export
 * @class SimulateAggregateBusinessApi
 * @extends {BaseAPI}
 */
export class SimulateAggregateBusinessApi extends BaseAPI {
    /**
     * 
     * @summary 在庫シミュレーション用の集計テーブル情報を取得する
     * @param {string} aggregateBusinessId 集計テーブルのID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulateAggregateBusinessApi
     */
    public simulateAggregateBusinessAggregateBusinessIdGet(aggregateBusinessId: string, options?: RawAxiosRequestConfig) {
        return SimulateAggregateBusinessApiFp(this.configuration).simulateAggregateBusinessAggregateBusinessIdGet(aggregateBusinessId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StdInventoryIndicesApi - axios parameter creator
 * @export
 */
export const StdInventoryIndicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 標準在庫指数を更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {StdInventoryIndicesAggregateBusinessIdPutRequest} stdInventoryIndicesAggregateBusinessIdPutRequest 標準在庫指数を更新する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stdInventoryIndicesAggregateBusinessIdPut: async (aggregateBusinessId: string, stdInventoryIndicesAggregateBusinessIdPutRequest: StdInventoryIndicesAggregateBusinessIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('stdInventoryIndicesAggregateBusinessIdPut', 'aggregateBusinessId', aggregateBusinessId)
            // verify required parameter 'stdInventoryIndicesAggregateBusinessIdPutRequest' is not null or undefined
            assertParamExists('stdInventoryIndicesAggregateBusinessIdPut', 'stdInventoryIndicesAggregateBusinessIdPutRequest', stdInventoryIndicesAggregateBusinessIdPutRequest)
            const localVarPath = `/std-inventory-indices/{aggregate_business_id}`
                .replace(`{${"aggregate_business_id"}}`, encodeURIComponent(String(aggregateBusinessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stdInventoryIndicesAggregateBusinessIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StdInventoryIndicesApi - functional programming interface
 * @export
 */
export const StdInventoryIndicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StdInventoryIndicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 標準在庫指数を更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {StdInventoryIndicesAggregateBusinessIdPutRequest} stdInventoryIndicesAggregateBusinessIdPutRequest 標準在庫指数を更新する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stdInventoryIndicesAggregateBusinessIdPut(aggregateBusinessId: string, stdInventoryIndicesAggregateBusinessIdPutRequest: StdInventoryIndicesAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stdInventoryIndicesAggregateBusinessIdPut(aggregateBusinessId, stdInventoryIndicesAggregateBusinessIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StdInventoryIndicesApi.stdInventoryIndicesAggregateBusinessIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StdInventoryIndicesApi - factory interface
 * @export
 */
export const StdInventoryIndicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StdInventoryIndicesApiFp(configuration)
    return {
        /**
         * 
         * @summary 標準在庫指数を更新する
         * @param {string} aggregateBusinessId 集計テーブルのID
         * @param {StdInventoryIndicesAggregateBusinessIdPutRequest} stdInventoryIndicesAggregateBusinessIdPutRequest 標準在庫指数を更新する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stdInventoryIndicesAggregateBusinessIdPut(aggregateBusinessId: string, stdInventoryIndicesAggregateBusinessIdPutRequest: StdInventoryIndicesAggregateBusinessIdPutRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.stdInventoryIndicesAggregateBusinessIdPut(aggregateBusinessId, stdInventoryIndicesAggregateBusinessIdPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StdInventoryIndicesApi - object-oriented interface
 * @export
 * @class StdInventoryIndicesApi
 * @extends {BaseAPI}
 */
export class StdInventoryIndicesApi extends BaseAPI {
    /**
     * 
     * @summary 標準在庫指数を更新する
     * @param {string} aggregateBusinessId 集計テーブルのID
     * @param {StdInventoryIndicesAggregateBusinessIdPutRequest} stdInventoryIndicesAggregateBusinessIdPutRequest 標準在庫指数を更新する情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StdInventoryIndicesApi
     */
    public stdInventoryIndicesAggregateBusinessIdPut(aggregateBusinessId: string, stdInventoryIndicesAggregateBusinessIdPutRequest: StdInventoryIndicesAggregateBusinessIdPutRequest, options?: RawAxiosRequestConfig) {
        return StdInventoryIndicesApiFp(this.configuration).stdInventoryIndicesAggregateBusinessIdPut(aggregateBusinessId, stdInventoryIndicesAggregateBusinessIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StdInventoryIndicesMaxApi - axios parameter creator
 * @export
 */
export const StdInventoryIndicesMaxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 標準在庫指数(最大)一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stdInventoryIndicesMaxGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/std-inventory-indices-max`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StdInventoryIndicesMaxApi - functional programming interface
 * @export
 */
export const StdInventoryIndicesMaxApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StdInventoryIndicesMaxApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 標準在庫指数(最大)一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stdInventoryIndicesMaxGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StdInventoryIndicesMaxResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stdInventoryIndicesMaxGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StdInventoryIndicesMaxApi.stdInventoryIndicesMaxGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StdInventoryIndicesMaxApi - factory interface
 * @export
 */
export const StdInventoryIndicesMaxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StdInventoryIndicesMaxApiFp(configuration)
    return {
        /**
         * 
         * @summary 標準在庫指数(最大)一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stdInventoryIndicesMaxGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<StdInventoryIndicesMaxResponse> {
            return localVarFp.stdInventoryIndicesMaxGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StdInventoryIndicesMaxApi - object-oriented interface
 * @export
 * @class StdInventoryIndicesMaxApi
 * @extends {BaseAPI}
 */
export class StdInventoryIndicesMaxApi extends BaseAPI {
    /**
     * 
     * @summary 標準在庫指数(最大)一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StdInventoryIndicesMaxApi
     */
    public stdInventoryIndicesMaxGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return StdInventoryIndicesMaxApiFp(this.configuration).stdInventoryIndicesMaxGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StdInventoryIndicesMinApi - axios parameter creator
 * @export
 */
export const StdInventoryIndicesMinApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 標準在庫指数(最小)一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stdInventoryIndicesMinGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/std-inventory-indices-min`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StdInventoryIndicesMinApi - functional programming interface
 * @export
 */
export const StdInventoryIndicesMinApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StdInventoryIndicesMinApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 標準在庫指数(最小)一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stdInventoryIndicesMinGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StdInventoryIndicesMinResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stdInventoryIndicesMinGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StdInventoryIndicesMinApi.stdInventoryIndicesMinGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StdInventoryIndicesMinApi - factory interface
 * @export
 */
export const StdInventoryIndicesMinApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StdInventoryIndicesMinApiFp(configuration)
    return {
        /**
         * 
         * @summary 標準在庫指数(最小)一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stdInventoryIndicesMinGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<StdInventoryIndicesMinResponse> {
            return localVarFp.stdInventoryIndicesMinGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StdInventoryIndicesMinApi - object-oriented interface
 * @export
 * @class StdInventoryIndicesMinApi
 * @extends {BaseAPI}
 */
export class StdInventoryIndicesMinApi extends BaseAPI {
    /**
     * 
     * @summary 標準在庫指数(最小)一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StdInventoryIndicesMinApi
     */
    public stdInventoryIndicesMinGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return StdInventoryIndicesMinApiFp(this.configuration).stdInventoryIndicesMinGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupplierNameApi - axios parameter creator
 * @export
 */
export const SupplierNameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 仕入先名一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierNameGet: async (supplierNumber?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/supplier-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierNameApi - functional programming interface
 * @export
 */
export const SupplierNameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierNameApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 仕入先名一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supplierNameGet(supplierNumber?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supplierNameGet(supplierNumber, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierNameApi.supplierNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierNameApi - factory interface
 * @export
 */
export const SupplierNameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierNameApiFp(configuration)
    return {
        /**
         * 
         * @summary 仕入先名一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierNameGet(supplierNumber?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<SupplierNameResponse> {
            return localVarFp.supplierNameGet(supplierNumber, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierNameApi - object-oriented interface
 * @export
 * @class SupplierNameApi
 * @extends {BaseAPI}
 */
export class SupplierNameApi extends BaseAPI {
    /**
     * 
     * @summary 仕入先名一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierNameApi
     */
    public supplierNameGet(supplierNumber?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return SupplierNameApiFp(this.configuration).supplierNameGet(supplierNumber, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupplierNameFromMasterApi - axios parameter creator
 * @export
 */
export const SupplierNameFromMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 仕入先名,CD一覧を取得する（マスタから取る）
         * @param {string} [supplierName] 仕入先名
         * @param {string} [supplierNumber] 仕入先CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierNameFromMasterGet: async (supplierName?: string, supplierNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/supplier-name-from-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierNameFromMasterApi - functional programming interface
 * @export
 */
export const SupplierNameFromMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierNameFromMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 仕入先名,CD一覧を取得する（マスタから取る）
         * @param {string} [supplierName] 仕入先名
         * @param {string} [supplierNumber] 仕入先CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supplierNameFromMasterGet(supplierName?: string, supplierNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierNameFromMasterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supplierNameFromMasterGet(supplierName, supplierNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierNameFromMasterApi.supplierNameFromMasterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierNameFromMasterApi - factory interface
 * @export
 */
export const SupplierNameFromMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierNameFromMasterApiFp(configuration)
    return {
        /**
         * 
         * @summary 仕入先名,CD一覧を取得する（マスタから取る）
         * @param {string} [supplierName] 仕入先名
         * @param {string} [supplierNumber] 仕入先CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierNameFromMasterGet(supplierName?: string, supplierNumber?: string, options?: any): AxiosPromise<SupplierNameFromMasterResponse> {
            return localVarFp.supplierNameFromMasterGet(supplierName, supplierNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierNameFromMasterApi - object-oriented interface
 * @export
 * @class SupplierNameFromMasterApi
 * @extends {BaseAPI}
 */
export class SupplierNameFromMasterApi extends BaseAPI {
    /**
     * 
     * @summary 仕入先名,CD一覧を取得する（マスタから取る）
     * @param {string} [supplierName] 仕入先名
     * @param {string} [supplierNumber] 仕入先CD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierNameFromMasterApi
     */
    public supplierNameFromMasterGet(supplierName?: string, supplierNumber?: string, options?: RawAxiosRequestConfig) {
        return SupplierNameFromMasterApiFp(this.configuration).supplierNameFromMasterGet(supplierName, supplierNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupplierNumberApi - axios parameter creator
 * @export
 */
export const SupplierNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 仕入先CD一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierNumberGet: async (supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/supplier-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierNumberApi - functional programming interface
 * @export
 */
export const SupplierNumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierNumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 仕入先CD一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supplierNumberGet(supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supplierNumberGet(supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierNumberApi.supplierNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierNumberApi - factory interface
 * @export
 */
export const SupplierNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierNumberApiFp(configuration)
    return {
        /**
         * 
         * @summary 仕入先CD一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supplierNumberGet(supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<SupplierNumberResponse> {
            return localVarFp.supplierNumberGet(supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierNumberApi - object-oriented interface
 * @export
 * @class SupplierNumberApi
 * @extends {BaseAPI}
 */
export class SupplierNumberApi extends BaseAPI {
    /**
     * 
     * @summary 仕入先CD一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierNumberApi
     */
    public supplierNumberGet(supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return SupplierNumberApiFp(this.configuration).supplierNumberGet(supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnitApi - axios parameter creator
 * @export
 */
export const UnitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 単位一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/unit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitApi - functional programming interface
 * @export
 */
export const UnitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 単位一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unitGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unitGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitApi.unitGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnitApi - factory interface
 * @export
 */
export const UnitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitApiFp(configuration)
    return {
        /**
         * 
         * @summary 単位一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [warehouse] 倉庫
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<UnitResponse> {
            return localVarFp.unitGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnitApi - object-oriented interface
 * @export
 * @class UnitApi
 * @extends {BaseAPI}
 */
export class UnitApi extends BaseAPI {
    /**
     * 
     * @summary 単位一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [warehouse] 倉庫
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitApi
     */
    public unitGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, warehouse?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return UnitApiFp(this.configuration).unitGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, warehouse, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WarehouseApi - axios parameter creator
 * @export
 */
export const WarehouseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 倉庫一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/warehouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarehouseApi - functional programming interface
 * @export
 */
export const WarehouseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarehouseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 倉庫一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarehouseApi.warehouseGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WarehouseApi - factory interface
 * @export
 */
export const WarehouseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarehouseApiFp(configuration)
    return {
        /**
         * 
         * @summary 倉庫一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<WarehouseResponse> {
            return localVarFp.warehouseGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarehouseApi - object-oriented interface
 * @export
 * @class WarehouseApi
 * @extends {BaseAPI}
 */
export class WarehouseApi extends BaseAPI {
    /**
     * 
     * @summary 倉庫一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public warehouseGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouseNumber?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return WarehouseApiFp(this.configuration).warehouseGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouseNumber, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WarehouseFromMasterApi - axios parameter creator
 * @export
 */
export const WarehouseFromMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 倉庫CD,名一覧を取得する（マスタから取得する）
         * @param {string} [warehouse] 倉庫
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseFromMasterGet: async (warehouse?: string, warehouseNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/warehouse-from-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (warehouseNumber !== undefined) {
                localVarQueryParameter['warehouseNumber'] = warehouseNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarehouseFromMasterApi - functional programming interface
 * @export
 */
export const WarehouseFromMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarehouseFromMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 倉庫CD,名一覧を取得する（マスタから取得する）
         * @param {string} [warehouse] 倉庫
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseFromMasterGet(warehouse?: string, warehouseNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseFromMasterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseFromMasterGet(warehouse, warehouseNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarehouseFromMasterApi.warehouseFromMasterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WarehouseFromMasterApi - factory interface
 * @export
 */
export const WarehouseFromMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarehouseFromMasterApiFp(configuration)
    return {
        /**
         * 
         * @summary 倉庫CD,名一覧を取得する（マスタから取得する）
         * @param {string} [warehouse] 倉庫
         * @param {string} [warehouseNumber] 倉庫CD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseFromMasterGet(warehouse?: string, warehouseNumber?: string, options?: any): AxiosPromise<WarehouseFromMasterResponse> {
            return localVarFp.warehouseFromMasterGet(warehouse, warehouseNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarehouseFromMasterApi - object-oriented interface
 * @export
 * @class WarehouseFromMasterApi
 * @extends {BaseAPI}
 */
export class WarehouseFromMasterApi extends BaseAPI {
    /**
     * 
     * @summary 倉庫CD,名一覧を取得する（マスタから取得する）
     * @param {string} [warehouse] 倉庫
     * @param {string} [warehouseNumber] 倉庫CD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseFromMasterApi
     */
    public warehouseFromMasterGet(warehouse?: string, warehouseNumber?: string, options?: RawAxiosRequestConfig) {
        return WarehouseFromMasterApiFp(this.configuration).warehouseFromMasterGet(warehouse, warehouseNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WarehouseNumberApi - axios parameter creator
 * @export
 */
export const WarehouseNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 倉庫CD一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseNumberGet: async (supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/warehouse-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (supplierNumber !== undefined) {
                localVarQueryParameter['supplierNumber'] = supplierNumber;
            }

            if (supplierName !== undefined) {
                localVarQueryParameter['supplierName'] = supplierName;
            }

            if (businessNumber !== undefined) {
                localVarQueryParameter['businessNumber'] = businessNumber;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['businessName'] = businessName;
            }

            if (_package !== undefined) {
                localVarQueryParameter['package'] = _package;
            }

            if (warehouse !== undefined) {
                localVarQueryParameter['warehouse'] = warehouse;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (manufacturer !== undefined) {
                localVarQueryParameter['manufacturer'] = manufacturer;
            }

            if (leadTimeInfo !== undefined) {
                for (const [key, value] of Object.entries(leadTimeInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMinInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMinInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (stdInventoryIndicesMaxInfo !== undefined) {
                for (const [key, value] of Object.entries(stdInventoryIndicesMaxInfo)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (moq !== undefined) {
                localVarQueryParameter['moq'] = moq;
            }

            if (aggregateBusinessResponsibleUserId !== undefined) {
                localVarQueryParameter['aggregateBusinessResponsibleUserId'] = aggregateBusinessResponsibleUserId;
            }

            if (orderPackage !== undefined) {
                localVarQueryParameter['orderPackage'] = orderPackage;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarehouseNumberApi - functional programming interface
 * @export
 */
export const WarehouseNumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarehouseNumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 倉庫CD一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warehouseNumberGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warehouseNumberGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WarehouseNumberApi.warehouseNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WarehouseNumberApi - factory interface
 * @export
 */
export const WarehouseNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarehouseNumberApiFp(configuration)
    return {
        /**
         * 
         * @summary 倉庫CD一覧を取得する（クエリパラメータで絞り込みを行える）
         * @param {string} [supplierNumber] 仕入先CD
         * @param {string} [supplierName] 仕入先名
         * @param {string} [businessNumber] 商品コード
         * @param {string} [businessName] 商品名
         * @param {string} [_package] 容量
         * @param {string} [warehouse] 倉庫
         * @param {string} [unit] 単位
         * @param {string} [manufacturer] 製造社
         * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
         * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
         * @param {number} [moq] MOQ
         * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
         * @param {string} [orderPackage] 発注単位
         * @param {string} [keyWord] 検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warehouseNumberGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: any): AxiosPromise<WarehouseNumberResponse> {
            return localVarFp.warehouseNumberGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarehouseNumberApi - object-oriented interface
 * @export
 * @class WarehouseNumberApi
 * @extends {BaseAPI}
 */
export class WarehouseNumberApi extends BaseAPI {
    /**
     * 
     * @summary 倉庫CD一覧を取得する（クエリパラメータで絞り込みを行える）
     * @param {string} [supplierNumber] 仕入先CD
     * @param {string} [supplierName] 仕入先名
     * @param {string} [businessNumber] 商品コード
     * @param {string} [businessName] 商品名
     * @param {string} [_package] 容量
     * @param {string} [warehouse] 倉庫
     * @param {string} [unit] 単位
     * @param {string} [manufacturer] 製造社
     * @param {LeadTimeInfo} [leadTimeInfo] リードタイム情報
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMinInfo] 最大在庫指数(最小)
     * @param {StdInventoryIndicesInfo} [stdInventoryIndicesMaxInfo] 最大在庫指数(最大)
     * @param {number} [moq] MOQ
     * @param {string} [aggregateBusinessResponsibleUserId] 集計取引担当者ID
     * @param {string} [orderPackage] 発注単位
     * @param {string} [keyWord] 検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseNumberApi
     */
    public warehouseNumberGet(supplierNumber?: string, supplierName?: string, businessNumber?: string, businessName?: string, _package?: string, warehouse?: string, unit?: string, manufacturer?: string, leadTimeInfo?: LeadTimeInfo, stdInventoryIndicesMinInfo?: StdInventoryIndicesInfo, stdInventoryIndicesMaxInfo?: StdInventoryIndicesInfo, moq?: number, aggregateBusinessResponsibleUserId?: string, orderPackage?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return WarehouseNumberApiFp(this.configuration).warehouseNumberGet(supplierNumber, supplierName, businessNumber, businessName, _package, warehouse, unit, manufacturer, leadTimeInfo, stdInventoryIndicesMinInfo, stdInventoryIndicesMaxInfo, moq, aggregateBusinessResponsibleUserId, orderPackage, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



